const data = {
  UCB: {
    net: [
      {
        title: 'Pornographic film actor',
        net: 183596,
        total: 183596,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Pornographic_film_actor',
      },
      {
        title: 'Creole Renaissance',
        net: 96575,
        total: 96575,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Creole_Renaissance',
      },
      {
        title: 'Gerald Rudolff Ford',
        net: 95290,
        total: 95290,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Gerald_Rudolff_Ford',
      },
      {
        title: 'User:Deciwill',
        net: 93767,
        total: 115653,
        unique_editors: 1,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/User:Deciwill',
      },
      {
        title: 'Diabetes',
        net: 87352,
        total: 87352,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Diabetes',
      },
      {
        title: 'My Little Pony',
        net: 84551,
        total: 84551,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/My_Little_Pony',
      },
      {
        title: 'Mahmoud Ahmadinejad',
        net: 72905,
        total: 72905,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Mahmoud_Ahmadinejad',
      },
      {
        title: 'Sex position',
        net: 68273,
        total: 68273,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sex_position',
      },
      {
        title: 'Greece',
        net: 62242,
        total: 62242,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Greece',
      },
      {
        title: 'Makkah',
        net: 48796,
        total: 48796,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Mecca',
      },
      {
        title: 'Extinction',
        net: 48472,
        total: 48472,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Extinction',
      },
      {
        title: 'Campania',
        net: 46525,
        total: 46525,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Campania',
      },
      {
        title: 'Hylidae',
        net: 35724,
        total: 35724,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Hylidae',
      },
      {
        title: 'Talk:Internment of Japanese Americans',
        net: 28423,
        total: 28423,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Internment_of_Japanese_Americans',
      },
      {
        title: 'Khatri',
        net: 22626,
        total: 27382,
        unique_editors: 3,
        edits: 48,
        urls: 'https://en.wikipedia.org/wiki/Khatri',
      },
    ],
    total: [
      {
        title: 'Spirogyra',
        net: -294242,
        total: 294244,
        unique_editors: 4,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Spirogyra',
      },
      {
        title: 'John Kerry',
        net: -228096,
        total: 228620,
        unique_editors: 3,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/John_Kerry',
      },
      {
        title: 'Pornographic film actor',
        net: 183596,
        total: 183596,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Pornographic_film_actor',
      },
      {
        title: 'Franz Liszt',
        net: -181811,
        total: 181811,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Franz_Liszt',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -132687,
        total: 155259,
        unique_editors: 36,
        edits: 153,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'University of California, Berkeley',
        net: -106819,
        total: 122935,
        unique_editors: 135,
        edits: 191,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Berkeley',
      },
      {
        title: 'Stanford University',
        net: -111488,
        total: 119580,
        unique_editors: 40,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Stanford_University',
      },
      {
        title: 'User:Deciwill',
        net: 93767,
        total: 115653,
        unique_editors: 1,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/User:Deciwill',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: -105291,
        total: 112701,
        unique_editors: 30,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Punjabi Khatri',
        net: -96324,
        total: 109988,
        unique_editors: 3,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Khatri',
      },
      {
        title: 'Creole Renaissance',
        net: 96575,
        total: 96575,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Creole_Renaissance',
      },
      {
        title: 'Gerald Rudolff Ford',
        net: 95290,
        total: 95290,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Gerald_Rudolff_Ford',
      },
      {
        title: 'Monopoly (game)',
        net: -93622,
        total: 93982,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Monopoly_(game)',
      },
      {
        title: 'Talk:Australian rules football/Archive 1',
        net: -89393,
        total: 89393,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Australian_rules_football/Archive_1',
      },
      {
        title: 'Diabetes',
        net: 87352,
        total: 87352,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Diabetes',
      },
    ],
    unique: [
      {
        title: 'University of California, Berkeley',
        net: -106819,
        total: 122935,
        unique_editors: 135,
        edits: 191,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Berkeley',
      },
      {
        title: 'Bowles Hall',
        net: 2759,
        total: 8171,
        unique_editors: 41,
        edits: 60,
        urls: 'https://en.wikipedia.org/wiki/Bowles_Hall',
      },
      {
        title: 'Stanford University',
        net: -111488,
        total: 119580,
        unique_editors: 40,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Stanford_University',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -132687,
        total: 155259,
        unique_editors: 36,
        edits: 153,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: -105291,
        total: 112701,
        unique_editors: 30,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Marvin Heemeyer',
        net: 3653,
        total: 7781,
        unique_editors: 24,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Marvin_Heemeyer',
      },
      {
        title: 'Wikipedia:Introduction (historical)',
        net: 861,
        total: 2099,
        unique_editors: 23,
        edits: 30,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Introduction_(historical)',
      },
      {
        title: 'List of University of California, Berkeley alumni',
        net: 1463,
        total: 1613,
        unique_editors: 20,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Berkeley_alumni',
      },
      {
        title: 'Big Game (American football)',
        net: 2043,
        total: 2099,
        unique_editors: 18,
        edits: 23,
        urls: 'https://en.wikipedia.org/wiki/Big_Game_(American_football)',
      },
      {
        title: 'University of California, Berkeley student housing',
        net: 2636,
        total: 6042,
        unique_editors: 17,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Berkeley_student_housing',
      },
      {
        title: 'Nicholas Dirks',
        net: 130,
        total: 3954,
        unique_editors: 17,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Nicholas_Dirks',
      },
      {
        title: 'Associated Students of the University of California',
        net: 3157,
        total: 5577,
        unique_editors: 17,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/Associated_Students_of_the_University_of_California',
      },
      {
        title: 'UC Berkeley School of Law',
        net: 284,
        total: 2190,
        unique_editors: 16,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/UC_Berkeley_School_of_Law',
      },
      {
        title: 'Lynbrook High School',
        net: -21514,
        total: 22674,
        unique_editors: 15,
        edits: 25,
        urls: 'https://en.wikipedia.org/wiki/Lynbrook_High_School',
      },
      {
        title: 'Experimental literature',
        net: 654,
        total: 1294,
        unique_editors: 15,
        edits: 37,
        urls: 'https://en.wikipedia.org/wiki/Experimental_literature',
      },
    ],
    edits: [
      {
        title: 'University of California, Berkeley',
        net: -106819,
        total: 122935,
        unique_editors: 135,
        edits: 191,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Berkeley',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -132687,
        total: 155259,
        unique_editors: 36,
        edits: 153,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'General semantics',
        net: -3520,
        total: 14278,
        unique_editors: 1,
        edits: 100,
        urls: 'https://en.wikipedia.org/wiki/General_semantics',
      },
      {
        title: 'User:Lensovet/cs162',
        net: 12255,
        total: 12483,
        unique_editors: 4,
        edits: 97,
        urls: 'https://en.wikipedia.org/wiki/User:Lensovet/cs162',
      },
      {
        title: 'Archaeal Richmond Mine acidophilic nanoorganisms',
        net: 7186,
        total: 9168,
        unique_editors: 3,
        edits: 85,
        urls: 'https://en.wikipedia.org/wiki/Archaeal_Richmond_Mine_acidophilic_nanoorganisms',
      },
      {
        title: 'Stanford University',
        net: -111488,
        total: 119580,
        unique_editors: 40,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Stanford_University',
      },
      {
        title: 'List of people associated with the London School of Economics',
        net: 4492,
        total: 5028,
        unique_editors: 12,
        edits: 72,
        urls: 'https://en.wikipedia.org/wiki/List_of_people_associated_with_the_London_School_of_Economics',
      },
      {
        title: 'Helen Tracy Lowe-Porter',
        net: 5708,
        total: 6754,
        unique_editors: 11,
        edits: 71,
        urls: 'https://en.wikipedia.org/wiki/Helen_Tracy_Lowe-Porter',
      },
      {
        title: 'Huo Yuanjia',
        net: 757,
        total: 3755,
        unique_editors: 4,
        edits: 70,
        urls: 'https://en.wikipedia.org/wiki/Huo_Yuanjia',
      },
      {
        title: 'Talk:Nagual',
        net: 3410,
        total: 3492,
        unique_editors: 4,
        edits: 68,
        urls: 'https://en.wikipedia.org/wiki/Talk:Nagual',
      },
      {
        title: 'Dilana',
        net: 2907,
        total: 5005,
        unique_editors: 1,
        edits: 67,
        urls: 'https://en.wikipedia.org/wiki/Dilana',
      },
      {
        title: 'Bowles Hall',
        net: 2759,
        total: 8171,
        unique_editors: 41,
        edits: 60,
        urls: 'https://en.wikipedia.org/wiki/Bowles_Hall',
      },
      {
        title: 'Ski touring',
        net: 3340,
        total: 4812,
        unique_editors: 1,
        edits: 55,
        urls: 'https://en.wikipedia.org/wiki/Ski_touring',
      },
      {
        title: 'Late Pleistocene extinctions',
        net: 1249,
        total: 1977,
        unique_editors: 3,
        edits: 55,
        urls: 'https://en.wikipedia.org/wiki/Late_Pleistocene_extinctions',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: -105291,
        total: 112701,
        unique_editors: 30,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
    ],
    net_asc: [
      {
        title: 'Spirogyra',
        net: -294242,
        total: 294244,
        unique_editors: 4,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Spirogyra',
      },
      {
        title: 'John Kerry',
        net: -228096,
        total: 228620,
        unique_editors: 3,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/John_Kerry',
      },
      {
        title: 'Franz Liszt',
        net: -181811,
        total: 181811,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Franz_Liszt',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -132687,
        total: 155259,
        unique_editors: 36,
        edits: 153,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Stanford University',
        net: -111488,
        total: 119580,
        unique_editors: 40,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Stanford_University',
      },
      {
        title: 'University of California, Berkeley',
        net: -106819,
        total: 122935,
        unique_editors: 135,
        edits: 191,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Berkeley',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: -105291,
        total: 112701,
        unique_editors: 30,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Punjabi Khatri',
        net: -96324,
        total: 109988,
        unique_editors: 3,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Khatri',
      },
      {
        title: 'Monopoly (game)',
        net: -93622,
        total: 93982,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Monopoly_(game)',
      },
      {
        title: 'Talk:Australian rules football/Archive 1',
        net: -89393,
        total: 89393,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Australian_rules_football/Archive_1',
      },
      {
        title: 'Edward Said',
        net: -79578,
        total: 79736,
        unique_editors: 2,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Edward_Said',
      },
      {
        title: 'Brad Pitt',
        net: -72880,
        total: 74542,
        unique_editors: 5,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/Brad_Pitt',
      },
      {
        title: 'Quakers',
        net: -64548,
        total: 64548,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Quakers',
      },
      {
        title: 'Christianity',
        net: -62539,
        total: 62637,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Christianity',
      },
      {
        title: 'Iranian Jews',
        net: -60751,
        total: 60751,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Iranian_Jews',
      },
    ],
  },
  UCD: {
    net: [
      {
        title: 'Wikipedia:Sandbox',
        net: 827808,
        total: 2118638,
        unique_editors: 29,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'List of people who have lived in airports',
        net: 111058,
        total: 111058,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/List_of_people_who_have_lived_in_airports',
      },
      {
        title: 'Biswanath Mukherjee',
        net: 77196,
        total: 77572,
        unique_editors: 2,
        edits: 21,
        urls: 'https://en.wikipedia.org/wiki/Biswanath_Mukherjee',
      },
      {
        title: 'Venus',
        net: 70029,
        total: 70029,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Venus',
      },
      {
        title: 'User:Tyomitch',
        net: 53600,
        total: 53600,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:Tyomitch',
      },
      {
        title: 'User:InShaneee',
        net: 53023,
        total: 53023,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:InShaneee',
      },
      {
        title: 'Adidas',
        net: 50186,
        total: 50186,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Adidas',
      },
      {
        title: 'Waldensians',
        net: 33250,
        total: 33250,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Waldensians',
      },
      {
        title: '2017 Sacramento Republic FC season',
        net: 24227,
        total: 29243,
        unique_editors: 1,
        edits: 230,
        urls: 'https://en.wikipedia.org/wiki/2017_Sacramento_Republic_FC_season',
      },
      {
        title: 'Stanley Williams',
        net: 21554,
        total: 21566,
        unique_editors: 4,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Stanley_Williams',
      },
      {
        title: 'Adi Da',
        net: 19142,
        total: 42450,
        unique_editors: 6,
        edits: 22,
        urls: 'https://en.wikipedia.org/wiki/Adi_Da',
      },
      {
        title: 'Miracle Train: Ōedo-sen e Yōkoso',
        net: 18701,
        total: 19585,
        unique_editors: 4,
        edits: 49,
        urls: 'https://en.wikipedia.org/wiki/Miracle_Train:_%C5%8Cedo-sen_e_Y%C5%8Dkoso',
      },
      {
        title: 'Richard Shelby',
        net: 16127,
        total: 16263,
        unique_editors: 1,
        edits: 27,
        urls: 'https://en.wikipedia.org/wiki/Richard_Shelby',
      },
      {
        title: 'Northern California Band Association',
        net: 15599,
        total: 15967,
        unique_editors: 1,
        edits: 23,
        urls: 'https://en.wikipedia.org/wiki/Northern_California_Band_Association',
      },
      {
        title: 'Hillary Scott (actress)',
        net: 13863,
        total: 13863,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Hillary_Scott_(actress)',
      },
    ],
    total: [
      {
        title: 'Wikipedia:Sandbox',
        net: 827808,
        total: 2118638,
        unique_editors: 29,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Resident Evil 4',
        net: -1305232,
        total: 1305232,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Resident_Evil_4',
      },
      {
        title: 'Bushism',
        net: 1004,
        total: 187518,
        unique_editors: 1,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Bushism',
      },
      {
        title: 'List of people who have lived in airports',
        net: 111058,
        total: 111058,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/List_of_people_who_have_lived_in_airports',
      },
      {
        title: 'American Broadcasting Company',
        net: -84080,
        total: 84080,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/American_Broadcasting_Company',
      },
      {
        title: 'Biswanath Mukherjee',
        net: 77196,
        total: 77572,
        unique_editors: 2,
        edits: 21,
        urls: 'https://en.wikipedia.org/wiki/Biswanath_Mukherjee',
      },
      {
        title: 'Venus',
        net: 70029,
        total: 70029,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Venus',
      },
      {
        title: 'JavaScript',
        net: -58385,
        total: 58451,
        unique_editors: 2,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/JavaScript',
      },
      {
        title: 'Taiwan (island)',
        net: -57236,
        total: 57236,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Geography_of_Taiwan',
      },
      {
        title: 'User talk:Kuban kazak',
        net: -56416,
        total: 56416,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Kuban_kazak',
      },
      {
        title: 'Volcano',
        net: -55222,
        total: 55240,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Volcano',
      },
      {
        title: 'Aristotle',
        net: -54857,
        total: 54857,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Aristotle',
      },
      {
        title: 'User:Tyomitch',
        net: 53600,
        total: 53600,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:Tyomitch',
      },
      {
        title: 'User:InShaneee',
        net: 53023,
        total: 53023,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:InShaneee',
      },
      {
        title: 'Adidas',
        net: 50186,
        total: 50186,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Adidas',
      },
    ],
    unique: [
      {
        title: 'University of California, Davis',
        net: -9424,
        total: 23066,
        unique_editors: 98,
        edits: 175,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Davis',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 827808,
        total: 2118638,
        unique_editors: 29,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'UC Davis School of Law',
        net: 738,
        total: 4986,
        unique_editors: 24,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_School_of_Law',
      },
      {
        title: 'Davis, California',
        net: -839,
        total: 3775,
        unique_editors: 22,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Davis,_California',
      },
      {
        title: 'List of University of California, Davis alumni',
        net: 1442,
        total: 2344,
        unique_editors: 15,
        edits: 30,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Davis_alumni',
      },
      {
        title: 'User:TCS 191/Know it All: Can Wikipedia conquer expertise?',
        net: 1488,
        total: 10980,
        unique_editors: 14,
        edits: 46,
        urls: 'https://en.wikipedia.org/wiki/User:TCS_191/Know_it_All:_Can_Wikipedia_conquer_expertise%3F',
      },
      {
        title: 'Wikipedia:Introduction (historical)',
        net: -21552,
        total: 35712,
        unique_editors: 13,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Introduction_(historical)',
      },
      {
        title: 'UC Davis School of Medicine',
        net: 336,
        total: 414,
        unique_editors: 13,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_School_of_Medicine',
      },
      {
        title: 'Picnic Day (UC Davis)',
        net: 4682,
        total: 8140,
        unique_editors: 12,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Picnic_Day_(UC_Davis)',
      },
      {
        title: 'The California Aggie',
        net: -297,
        total: 683,
        unique_editors: 11,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/The_California_Aggie',
      },
      {
        title: 'Silvetia',
        net: 4766,
        total: 6666,
        unique_editors: 11,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Silvetia',
      },
      {
        title: 'Archer (Fate/stay night)',
        net: 2039,
        total: 5091,
        unique_editors: 11,
        edits: 67,
        urls: 'https://en.wikipedia.org/wiki/List_of_Fate/stay_night_characters',
      },
      {
        title: 'UC Davis College of Engineering',
        net: 286,
        total: 468,
        unique_editors: 10,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_College_of_Engineering',
      },
      {
        title: 'UC Davis Medical Center',
        net: 11940,
        total: 19770,
        unique_editors: 9,
        edits: 63,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_Medical_Center',
      },
      {
        title: 'Sacramento, California',
        net: -219,
        total: 403,
        unique_editors: 9,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/Sacramento,_California',
      },
    ],
    edits: [
      {
        title: 'Pokhara',
        net: -1252,
        total: 19318,
        unique_editors: 6,
        edits: 238,
        urls: 'https://en.wikipedia.org/wiki/Pokhara',
      },
      {
        title: '2017 Sacramento Republic FC season',
        net: 24227,
        total: 29243,
        unique_editors: 1,
        edits: 230,
        urls: 'https://en.wikipedia.org/wiki/2017_Sacramento_Republic_FC_season',
      },
      {
        title: 'University of California, Davis',
        net: -9424,
        total: 23066,
        unique_editors: 98,
        edits: 175,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Davis',
      },
      {
        title: 'Prithvi Narayan Campus',
        net: 2155,
        total: 12381,
        unique_editors: 4,
        edits: 148,
        urls: 'https://en.wikipedia.org/wiki/Prithvi_Narayan_Campus',
      },
      {
        title: '2016 Sacramento Republic FC season',
        net: 8665,
        total: 9417,
        unique_editors: 1,
        edits: 134,
        urls: 'https://en.wikipedia.org/wiki/2016_Sacramento_Republic_FC_season',
      },
      {
        title: '2014–15 Middlesbrough F.C. season',
        net: 13700,
        total: 14500,
        unique_editors: 1,
        edits: 108,
        urls: 'https://en.wikipedia.org/wiki/2014%E2%80%9315_Middlesbrough_F.C._season',
      },
      {
        title: 'Archer (Fate/stay night)',
        net: 2039,
        total: 5091,
        unique_editors: 11,
        edits: 67,
        urls: 'https://en.wikipedia.org/wiki/List_of_Fate/stay_night_characters',
      },
      {
        title: 'Homeland for the Jewish people',
        net: 4474,
        total: 10702,
        unique_editors: 1,
        edits: 64,
        urls: 'https://en.wikipedia.org/wiki/Homeland_for_the_Jewish_people',
      },
      {
        title: 'UC Davis Medical Center',
        net: 11940,
        total: 19770,
        unique_editors: 9,
        edits: 63,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_Medical_Center',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 827808,
        total: 2118638,
        unique_editors: 29,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Abraham Lincoln High School (San Francisco)',
        net: 8193,
        total: 10265,
        unique_editors: 7,
        edits: 54,
        urls: 'https://en.wikipedia.org/wiki/Abraham_Lincoln_High_School_(San_Francisco)',
      },
      {
        title: 'UC Davis School of Law',
        net: 738,
        total: 4986,
        unique_editors: 24,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/UC_Davis_School_of_Law',
      },
      {
        title: '24 season 5',
        net: 1322,
        total: 2444,
        unique_editors: 2,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/24_season_5',
      },
      {
        title: 'Miracle Train: Ōedo-sen e Yōkoso',
        net: 18701,
        total: 19585,
        unique_editors: 4,
        edits: 49,
        urls: 'https://en.wikipedia.org/wiki/Miracle_Train:_%C5%8Cedo-sen_e_Y%C5%8Dkoso',
      },
      {
        title: 'Fate/stay night',
        net: 2873,
        total: 4033,
        unique_editors: 6,
        edits: 49,
        urls: 'https://en.wikipedia.org/wiki/Fate/stay_night',
      },
    ],
    net_asc: [
      {
        title: 'Resident Evil 4',
        net: -1305232,
        total: 1305232,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Resident_Evil_4',
      },
      {
        title: 'American Broadcasting Company',
        net: -84080,
        total: 84080,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/American_Broadcasting_Company',
      },
      {
        title: 'JavaScript',
        net: -58385,
        total: 58451,
        unique_editors: 2,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/JavaScript',
      },
      {
        title: 'Taiwan (island)',
        net: -57236,
        total: 57236,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Geography_of_Taiwan',
      },
      {
        title: 'User talk:Kuban kazak',
        net: -56416,
        total: 56416,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Kuban_kazak',
      },
      {
        title: 'Volcano',
        net: -55222,
        total: 55240,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Volcano',
      },
      {
        title: 'Aristotle',
        net: -54857,
        total: 54857,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Aristotle',
      },
      {
        title: 'Yolo County, California',
        net: -48022,
        total: 48230,
        unique_editors: 3,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Yolo_County,_California',
      },
      {
        title: 'Sniper',
        net: -41139,
        total: 41139,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sniper',
      },
      {
        title: 'San Francisco Giants',
        net: -36049,
        total: 46795,
        unique_editors: 3,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/San_Francisco_Giants',
      },
      {
        title: 'Bob Jones University',
        net: -33395,
        total: 33433,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Bob_Jones_University',
      },
      {
        title: 'Nigger',
        net: -29929,
        total: 30185,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Nigger',
      },
      {
        title: 'Seven deadly sins',
        net: -29758,
        total: 29758,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Seven_deadly_sins',
      },
      {
        title: 'Association football',
        net: -27362,
        total: 27408,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Association_football',
      },
      {
        title: 'Battle of Berlin',
        net: -25646,
        total: 25730,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Battle_of_Berlin',
      },
    ],
  },
  UCI: {
    net: [
      {
        title: 'The Hobbit',
        net: 218699,
        total: 218699,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/The_Hobbit',
      },
      {
        title: 'Reem Al Numery',
        net: 194401,
        total: 194401,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Reem_Al_Numery',
      },
      {
        title: 'Iraqi-American War',
        net: 78020,
        total: 78020,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Iraq_War_(disambiguation)',
      },
      {
        title: 'Toyota',
        net: 61680,
        total: 61680,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Toyota',
      },
      {
        title: 'Death of Anna Nicole Smith',
        net: 55268,
        total: 55330,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Anna_Nicole_Smith',
      },
      {
        title: 'Negotiation',
        net: 53816,
        total: 53816,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Negotiation',
      },
      {
        title: 'Republic',
        net: 42315,
        total: 42315,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Republic',
      },
      {
        title: 'NFE2L1',
        net: 28399,
        total: 29103,
        unique_editors: 1,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/NFE2L1',
      },
      {
        title: 'Mahavatar Babaji',
        net: 25825,
        total: 25955,
        unique_editors: 2,
        edits: 16,
        urls: 'https://en.wikipedia.org/wiki/Mahavatar_Babaji',
      },
      {
        title: 'Palestine (disambiguation)',
        net: 23373,
        total: 23373,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Palestine_(disambiguation)',
      },
      {
        title: 'Kriya Yoga school',
        net: 22610,
        total: 23166,
        unique_editors: 2,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Kriya_Yoga_school',
      },
      {
        title: 'Petlyakov Pe-2',
        net: 21791,
        total: 21793,
        unique_editors: 1,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/Petlyakov_Pe-2',
      },
      {
        title: 'Leopard',
        net: 21410,
        total: 21410,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Leopard',
      },
      {
        title: 'The Wild',
        net: 20345,
        total: 20345,
        unique_editors: 1,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/The_Wild',
      },
      {
        title: 'List of computer science conferences',
        net: 19731,
        total: 48661,
        unique_editors: 25,
        edits: 146,
        urls: 'https://en.wikipedia.org/wiki/List_of_computer_science_conferences',
      },
    ],
    total: [
      {
        title: 'Saxophone',
        net: -837635,
        total: 837635,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Saxophone',
      },
      {
        title: 'Stephen Hawking',
        net: -295722,
        total: 295722,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Stephen_Hawking',
      },
      {
        title: 'The Hobbit',
        net: 218699,
        total: 218699,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/The_Hobbit',
      },
      {
        title: 'Reem Al Numery',
        net: 194401,
        total: 194401,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Reem_Al_Numery',
      },
      {
        title: 'Harvard University',
        net: -140256,
        total: 141028,
        unique_editors: 4,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Harvard_University',
      },
      {
        title: 'Armenian genocide denial',
        net: -97505,
        total: 97505,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Armenian_genocide_denial',
      },
      {
        title: 'Iraqi-American War',
        net: 78020,
        total: 78020,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Iraq_War_(disambiguation)',
      },
      {
        title: '2003 invasion of Iraq',
        net: -77888,
        total: 77890,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/2003_invasion_of_Iraq',
      },
      {
        title: 'Etel Solingen',
        net: -27489,
        total: 70835,
        unique_editors: 6,
        edits: 70,
        urls: 'https://en.wikipedia.org/wiki/Etel_Solingen',
      },
      {
        title: 'NASA',
        net: -61687,
        total: 61687,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/NASA',
      },
      {
        title: 'Toyota',
        net: 61680,
        total: 61680,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Toyota',
      },
      {
        title: "Hundred Years' War",
        net: -58611,
        total: 58611,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Hundred_Years%27_War',
      },
      {
        title: 'Chinese civilization',
        net: 93,
        total: 55793,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Chinese_civilization',
      },
      {
        title: 'Death of Anna Nicole Smith',
        net: 55268,
        total: 55330,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Anna_Nicole_Smith',
      },
      {
        title: 'Negotiation',
        net: 53816,
        total: 53816,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Negotiation',
      },
    ],
    unique: [
      {
        title: 'University of California, Irvine',
        net: -3516,
        total: 53640,
        unique_editors: 198,
        edits: 316,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Irvine',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -6008,
        total: 34116,
        unique_editors: 29,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'List of computer science conferences',
        net: 19731,
        total: 48661,
        unique_editors: 25,
        edits: 146,
        urls: 'https://en.wikipedia.org/wiki/List_of_computer_science_conferences',
      },
      {
        title: 'Wikipedia:Introduction (historical)',
        net: 367,
        total: 17285,
        unique_editors: 17,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Introduction_(historical)',
      },
      {
        title: 'Bryan Reynolds (scholar)',
        net: 2785,
        total: 2837,
        unique_editors: 17,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Bryan_Reynolds_(scholar)',
      },
      {
        title: 'Paul Merage School of Business',
        net: 3100,
        total: 3340,
        unique_editors: 15,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/Paul_Merage_School_of_Business',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 13096,
        total: 39754,
        unique_editors: 14,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Orange County, California',
        net: 1395,
        total: 2591,
        unique_editors: 14,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/Orange_County,_California',
      },
      {
        title: 'Estradiol (medication)',
        net: 7534,
        total: 7692,
        unique_editors: 12,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Estradiol_(medication)',
      },
      {
        title: 'Bren Events Center',
        net: 348,
        total: 1988,
        unique_editors: 12,
        edits: 16,
        urls: 'https://en.wikipedia.org/wiki/Bren_Events_Center',
      },
      {
        title: 'List of University of California, Irvine people',
        net: 595,
        total: 917,
        unique_editors: 11,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Irvine_people',
      },
      {
        title: 'Estradiol undecylate',
        net: 3200,
        total: 3612,
        unique_editors: 11,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Estradiol_undecylate',
      },
      {
        title: 'Wikipedia:Tutorial (historical)/Editing/sandbox',
        net: -13022,
        total: 14598,
        unique_editors: 10,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Irvine, California',
        net: 689,
        total: 2069,
        unique_editors: 10,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/Irvine,_California',
      },
      {
        title: 'Sustainable fashion',
        net: 2459,
        total: 2511,
        unique_editors: 9,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/Sustainable_fashion',
      },
    ],
    edits: [
      {
        title: 'University of California, Irvine',
        net: -3516,
        total: 53640,
        unique_editors: 198,
        edits: 316,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Irvine',
      },
      {
        title: 'List of computer science conferences',
        net: 19731,
        total: 48661,
        unique_editors: 25,
        edits: 146,
        urls: 'https://en.wikipedia.org/wiki/List_of_computer_science_conferences',
      },
      {
        title: 'Cerritos, California',
        net: 6617,
        total: 16645,
        unique_editors: 6,
        edits: 76,
        urls: 'https://en.wikipedia.org/wiki/Cerritos,_California',
      },
      {
        title: 'Silver Surfer (TV series)',
        net: -6874,
        total: 9202,
        unique_editors: 2,
        edits: 70,
        urls: 'https://en.wikipedia.org/wiki/Silver_Surfer_(TV_series)',
      },
      {
        title: 'Etel Solingen',
        net: -27489,
        total: 70835,
        unique_editors: 6,
        edits: 70,
        urls: 'https://en.wikipedia.org/wiki/Etel_Solingen',
      },
      {
        title: 'Skip Beat! (Taiwanese TV series)',
        net: 3515,
        total: 4679,
        unique_editors: 3,
        edits: 65,
        urls: 'https://en.wikipedia.org/wiki/Skip_Beat!_(Taiwanese_TV_series)',
      },
      {
        title: 'Glenn Cannon (bassist)',
        net: 2106,
        total: 4882,
        unique_editors: 6,
        edits: 60,
        urls: 'https://en.wikipedia.org/wiki/Hellion_(band)',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -6008,
        total: 34116,
        unique_editors: 29,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Super Junior',
        net: -2387,
        total: 8685,
        unique_editors: 5,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Super_Junior',
      },
      {
        title: 'Jawbreaker (band)',
        net: 1622,
        total: 2306,
        unique_editors: 4,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Jawbreaker_(band)',
      },
      {
        title: 'Das Kapital',
        net: 2712,
        total: 3134,
        unique_editors: 4,
        edits: 43,
        urls: 'https://en.wikipedia.org/wiki/Das_Kapital',
      },
      {
        title: 'Rosy Business',
        net: 3843,
        total: 5005,
        unique_editors: 5,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/Rosy_Business',
      },
      {
        title: 'Orange County, California',
        net: 1395,
        total: 2591,
        unique_editors: 14,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/Orange_County,_California',
      },
      {
        title: 'Top Combine',
        net: 2078,
        total: 2910,
        unique_editors: 2,
        edits: 41,
        urls: 'https://en.wikipedia.org/wiki/Top_Combine',
      },
      {
        title: 'Shammar',
        net: 11790,
        total: 11966,
        unique_editors: 7,
        edits: 37,
        urls: 'https://en.wikipedia.org/wiki/Shammar',
      },
    ],
    net_asc: [
      {
        title: 'Saxophone',
        net: -837635,
        total: 837635,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Saxophone',
      },
      {
        title: 'Stephen Hawking',
        net: -295722,
        total: 295722,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Stephen_Hawking',
      },
      {
        title: 'Harvard University',
        net: -140256,
        total: 141028,
        unique_editors: 4,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Harvard_University',
      },
      {
        title: 'Armenian genocide denial',
        net: -97505,
        total: 97505,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Armenian_genocide_denial',
      },
      {
        title: '2003 invasion of Iraq',
        net: -77888,
        total: 77890,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/2003_invasion_of_Iraq',
      },
      {
        title: 'NASA',
        net: -61687,
        total: 61687,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/NASA',
      },
      {
        title: "Hundred Years' War",
        net: -58611,
        total: 58611,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Hundred_Years%27_War',
      },
      {
        title: 'Facebook',
        net: -49921,
        total: 52889,
        unique_editors: 3,
        edits: 13,
        urls: 'https://en.wikipedia.org/wiki/Facebook',
      },
      {
        title: "Shaquille O'Neal",
        net: -48557,
        total: 48557,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Shaquille_O%27Neal',
      },
      {
        title: 'Mel Gibson',
        net: -47923,
        total: 47923,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Mel_Gibson',
      },
      {
        title: 'Ambiguity',
        net: -47742,
        total: 47770,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Ambiguity',
      },
      {
        title: 'Barry Bonds',
        net: -44832,
        total: 45136,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Barry_Bonds',
      },
      {
        title: 'Rent (musical)',
        net: -40763,
        total: 40831,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Rent_(musical)',
      },
      {
        title: 'Sodomy law',
        net: -40669,
        total: 40669,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sodomy_law',
      },
      {
        title: 'Common Core',
        net: -37123,
        total: 37123,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Common_Core',
      },
    ],
  },
  UCLA: {
    net: [
      {
        title: 'Leonardo DiCaprio',
        net: 2756932,
        total: 2756944,
        unique_editors: 3,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Leonardo_DiCaprio',
      },
      {
        title: 'Wikipedia:Sandbox/Archive2',
        net: 1349415,
        total: 1349415,
        unique_editors: 4,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive2',
      },
      {
        title: 'Queen Adreena',
        net: 795873,
        total: 795873,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Queenadreena',
      },
      {
        title: 'Wikipedia:Counter-Vandalism Unit',
        net: 794813,
        total: 794813,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Counter-Vandalism_Unit',
      },
      {
        title: 'User:Beardo',
        net: 792766,
        total: 797958,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Beardo',
      },
      {
        title: 'History of Estonia',
        net: 475291,
        total: 475291,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/History_of_Estonia',
      },
      {
        title: '1996 California Proposition 218',
        net: 165497,
        total: 166107,
        unique_editors: 10,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/1996_California_Proposition_218',
      },
      {
        title: 'Bellarmine College Preparatory',
        net: 104524,
        total: 104796,
        unique_editors: 6,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Bellarmine_College_Preparatory',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (F)',
        net: 96788,
        total: 175508,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(F)',
      },
      {
        title: 'Greeks',
        net: 88698,
        total: 88698,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Greeks',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (E)',
        net: 87243,
        total: 169795,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(E)',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (B)',
        net: 79623,
        total: 159027,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(B)',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (D)',
        net: 77560,
        total: 166264,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(D)',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (C)',
        net: 66769,
        total: 246407,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(C)',
      },
      {
        title: 'User:Mathbot/Page10',
        net: 58986,
        total: 58986,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/Page10',
      },
    ],
    total: [
      {
        title: 'Leonardo DiCaprio',
        net: 2756932,
        total: 2756944,
        unique_editors: 3,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Leonardo_DiCaprio',
      },
      {
        title: 'Wikipedia:Sandbox/Archive2',
        net: 1349415,
        total: 1349415,
        unique_editors: 4,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive2',
      },
      {
        title: 'User:Beardo',
        net: 792766,
        total: 797958,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Beardo',
      },
      {
        title: 'Queen Adreena',
        net: 795873,
        total: 795873,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Queenadreena',
      },
      {
        title: 'Wikipedia:Counter-Vandalism Unit',
        net: 794813,
        total: 794813,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Counter-Vandalism_Unit',
      },
      {
        title: 'History of Estonia',
        net: 475291,
        total: 475291,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/History_of_Estonia',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (A)',
        net: 37346,
        total: 408372,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(A)',
      },
      {
        title: 'FIFA World Cup qualifiers',
        net: -345867,
        total: 345873,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/FIFA_World_Cup_qualifiers',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (C)',
        net: 66769,
        total: 246407,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(C)',
      },
      {
        title: 'Talk:Bronze Soldier of Tallinn',
        net: -238777,
        total: 239761,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Talk:Bronze_Soldier_of_Tallinn',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (F)',
        net: 96788,
        total: 175508,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(F)',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (E)',
        net: 87243,
        total: 169795,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(E)',
      },
      {
        title: 'Wikipedia:Version 1.0 Editorial Team/French military history articles by quality log',
        net: -166794,
        total: 166794,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Version_1.0_Editorial_Team/French_military_history_articles_by_quality_log',
      },
      {
        title: 'User:Mathbot/List of mathematical redlinks (D)',
        net: 77560,
        total: 166264,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/List_of_mathematical_redlinks_(D)',
      },
      {
        title: '1996 California Proposition 218',
        net: 165497,
        total: 166107,
        unique_editors: 10,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/1996_California_Proposition_218',
      },
    ],
    unique: [
      {
        title: 'University of California, Los Angeles',
        net: 5904,
        total: 106764,
        unique_editors: 218,
        edits: 377,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Los_Angeles',
      },
      {
        title: 'List of University of California, Los Angeles people',
        net: 3853,
        total: 5557,
        unique_editors: 56,
        edits: 93,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Los_Angeles_people',
      },
      {
        title: 'Wikipedia:Reference desk/Computing',
        net: 21123,
        total: 21133,
        unique_editors: 48,
        edits: 71,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Computing',
      },
      {
        title: 'University of Southern California',
        net: -92599,
        total: 101685,
        unique_editors: 44,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/University_of_Southern_California',
      },
      {
        title: 'Sukhoi Su-57',
        net: 2798,
        total: 5680,
        unique_editors: 42,
        edits: 103,
        urls: 'https://en.wikipedia.org/wiki/Sukhoi_Su-57',
      },
      {
        title: 'Lockheed Martin F-22 Raptor',
        net: -14888,
        total: 16378,
        unique_editors: 39,
        edits: 87,
        urls: 'https://en.wikipedia.org/wiki/Lockheed_Martin_F-22_Raptor',
      },
      {
        title: 'UCLA Spring Sing',
        net: 2657,
        total: 4677,
        unique_editors: 38,
        edits: 66,
        urls: 'https://en.wikipedia.org/wiki/UCLA_Spring_Sing',
      },
      {
        title: 'Gene Block',
        net: 1207,
        total: 1887,
        unique_editors: 38,
        edits: 54,
        urls: 'https://en.wikipedia.org/wiki/Gene_Block',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -3319,
        total: 35085,
        unique_editors: 37,
        edits: 72,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Wikipedia:Introduction (historical)',
        net: 1366,
        total: 2264,
        unique_editors: 33,
        edits: 40,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Introduction_(historical)',
      },
      {
        title: 'List of fictional felines',
        net: 5354,
        total: 5442,
        unique_editors: 32,
        edits: 69,
        urls: 'https://en.wikipedia.org/wiki/List_of_fictional_felines',
      },
      {
        title: 'Modesto, California',
        net: 1801,
        total: 3305,
        unique_editors: 31,
        edits: 98,
        urls: 'https://en.wikipedia.org/wiki/Modesto,_California',
      },
      {
        title: 'Soccer in the United States',
        net: 974,
        total: 5864,
        unique_editors: 30,
        edits: 78,
        urls: 'https://en.wikipedia.org/wiki/Soccer_in_the_United_States',
      },
      {
        title: 'List of future stadiums',
        net: 1308,
        total: 9790,
        unique_editors: 30,
        edits: 84,
        urls: 'https://en.wikipedia.org/wiki/List_of_future_stadiums',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 35870,
        total: 37186,
        unique_editors: 28,
        edits: 44,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
    ],
    edits: [
      {
        title: 'University of California, Los Angeles',
        net: 5904,
        total: 106764,
        unique_editors: 218,
        edits: 377,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Los_Angeles',
      },
      {
        title: 'User:N-true/ASJP',
        net: 26447,
        total: 53577,
        unique_editors: 1,
        edits: 193,
        urls: 'https://en.wikipedia.org/wiki/User:N-true/ASJP',
      },
      {
        title: 'UCLA Bruin Marching Band',
        net: 8782,
        total: 13042,
        unique_editors: 23,
        edits: 146,
        urls: 'https://en.wikipedia.org/wiki/UCLA_Bruin_Marching_Band',
      },
      {
        title: 'Jack Sperling',
        net: 3507,
        total: 6623,
        unique_editors: 9,
        edits: 123,
        urls: 'https://en.wikipedia.org/wiki/Jack_Sperling',
      },
      {
        title: 'Chail Military School',
        net: 13390,
        total: 15568,
        unique_editors: 6,
        edits: 113,
        urls: 'https://en.wikipedia.org/wiki/Chail_Military_School',
      },
      {
        title: 'Sukhoi Su-57',
        net: 2798,
        total: 5680,
        unique_editors: 42,
        edits: 103,
        urls: 'https://en.wikipedia.org/wiki/Sukhoi_Su-57',
      },
      {
        title: 'Template:Los Angeles Dodgers roster',
        net: 319,
        total: 1147,
        unique_editors: 18,
        edits: 98,
        urls: 'https://en.wikipedia.org/wiki/Template:Los_Angeles_Dodgers_roster',
      },
      {
        title: 'Modesto, California',
        net: 1801,
        total: 3305,
        unique_editors: 31,
        edits: 98,
        urls: 'https://en.wikipedia.org/wiki/Modesto,_California',
      },
      {
        title: 'List of University of California, Los Angeles people',
        net: 3853,
        total: 5557,
        unique_editors: 56,
        edits: 93,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Los_Angeles_people',
      },
      {
        title: 'Template:Los Angeles Rams roster',
        net: -214,
        total: 2098,
        unique_editors: 23,
        edits: 92,
        urls: 'https://en.wikipedia.org/wiki/Template:Los_Angeles_Rams_roster',
      },
      {
        title: 'Mochi (magazine)',
        net: 4216,
        total: 7476,
        unique_editors: 12,
        edits: 90,
        urls: 'https://en.wikipedia.org/wiki/Mochi_(magazine)',
      },
      {
        title: 'Lockheed Martin F-22 Raptor',
        net: -14888,
        total: 16378,
        unique_editors: 39,
        edits: 87,
        urls: 'https://en.wikipedia.org/wiki/Lockheed_Martin_F-22_Raptor',
      },
      {
        title: 'American University',
        net: 16981,
        total: 18239,
        unique_editors: 16,
        edits: 87,
        urls: 'https://en.wikipedia.org/wiki/American_University',
      },
      {
        title: 'List of future stadiums',
        net: 1308,
        total: 9790,
        unique_editors: 30,
        edits: 84,
        urls: 'https://en.wikipedia.org/wiki/List_of_future_stadiums',
      },
      {
        title: "United States men's national soccer team",
        net: 1396,
        total: 7232,
        unique_editors: 23,
        edits: 82,
        urls: 'https://en.wikipedia.org/wiki/United_States_men%27s_national_soccer_team',
      },
    ],
    net_asc: [
      {
        title: 'FIFA World Cup qualifiers',
        net: -345867,
        total: 345873,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/FIFA_World_Cup_qualifiers',
      },
      {
        title: 'Talk:Bronze Soldier of Tallinn',
        net: -238777,
        total: 239761,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Talk:Bronze_Soldier_of_Tallinn',
      },
      {
        title: 'Wikipedia:Version 1.0 Editorial Team/French military history articles by quality log',
        net: -166794,
        total: 166794,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Version_1.0_Editorial_Team/French_military_history_articles_by_quality_log',
      },
      {
        title: 'Trey Ellis',
        net: -165532,
        total: 165532,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Trey_Ellis',
      },
      {
        title: 'Borat',
        net: -117931,
        total: 117933,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Borat',
      },
      {
        title: 'Tajiks',
        net: -110686,
        total: 110858,
        unique_editors: 4,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Tajiks',
      },
      {
        title: '2022–23 ECHL season',
        net: -108692,
        total: 108702,
        unique_editors: 3,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/2022%E2%80%9323_ECHL_season',
      },
      {
        title: 'Moon landing conspiracy theories',
        net: -107213,
        total: 107213,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Moon_landing_conspiracy_theories',
      },
      {
        title: 'Talk:Karyn Kupcinet/Archive 1',
        net: -107003,
        total: 107003,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Talk:Karyn_Kupcinet/Archive_1',
      },
      {
        title: 'User:Mathbot/Most recent admin candidate',
        net: -106761,
        total: 106801,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:Mathbot/Most_recent_admin_candidate',
      },
      {
        title: 'University of Southern California',
        net: -92599,
        total: 101685,
        unique_editors: 44,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/University_of_Southern_California',
      },
      {
        title: 'Talk:Estonia',
        net: -92122,
        total: 112778,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Talk:Estonia',
      },
      {
        title: 'Ricky Williams',
        net: -84111,
        total: 84259,
        unique_editors: 4,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/Ricky_Williams',
      },
      {
        title: 'Bahrain',
        net: -73073,
        total: 73073,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Bahrain',
      },
      {
        title: 'Sleep',
        net: -72483,
        total: 72483,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Sleep',
      },
    ],
  },
  UCM: {
    net: [
      {
        title: 'Parthia',
        net: 40712,
        total: 40712,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Parthia',
      },
      {
        title: 'List of Black Clover characters',
        net: 13361,
        total: 13399,
        unique_editors: 2,
        edits: 143,
        urls: 'https://en.wikipedia.org/wiki/List_of_Black_Clover_characters',
      },
      {
        title: 'University of California, Merced',
        net: 8887,
        total: 18013,
        unique_editors: 114,
        edits: 195,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Merced',
      },
      {
        title: 'Calibishie',
        net: 3892,
        total: 3892,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Calibishie',
      },
      {
        title: 'FAFSA',
        net: 3608,
        total: 3608,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/FAFSA',
      },
      {
        title: 'Cognitive dissonance',
        net: 2742,
        total: 2742,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Cognitive_dissonance',
      },
      {
        title: 'Talk:Merced Assembly Center',
        net: 2686,
        total: 2690,
        unique_editors: 2,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/Talk:Merced_Assembly_Center',
      },
      {
        title: 'Europa Universalis III',
        net: 2548,
        total: 2568,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Europa_Universalis_III',
      },
      {
        title: 'Verne Winchell',
        net: 2290,
        total: 2290,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Verne_Winchell',
      },
      {
        title: 'Something Awful',
        net: 2235,
        total: 2235,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Something_Awful',
      },
      {
        title: 'User talk:Ocatecir',
        net: 2208,
        total: 2208,
        unique_editors: 4,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Ocatecir',
      },
      {
        title: 'Jean Piaget',
        net: 2029,
        total: 2029,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Jean_Piaget',
      },
      {
        title: 'Nuance Communications',
        net: 1895,
        total: 1895,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Nuance_Communications',
      },
      {
        title: 'David Hilbert',
        net: 1705,
        total: 1705,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/David_Hilbert',
      },
      {
        title: 'Jutsu (Naruto)',
        net: 1650,
        total: 1768,
        unique_editors: 2,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Naruto',
      },
    ],
    total: [
      {
        title: 'Talk:University of California, Merced',
        net: -48412,
        total: 50108,
        unique_editors: 9,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Merced',
      },
      {
        title: 'Parthia',
        net: 40712,
        total: 40712,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Parthia',
      },
      {
        title: 'University of California, Merced',
        net: 8887,
        total: 18013,
        unique_editors: 114,
        edits: 195,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Merced',
      },
      {
        title: 'List of Black Clover characters',
        net: 13361,
        total: 13399,
        unique_editors: 2,
        edits: 143,
        urls: 'https://en.wikipedia.org/wiki/List_of_Black_Clover_characters',
      },
      {
        title: 'Snob',
        net: -5936,
        total: 6212,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Snob',
      },
      {
        title: 'Sugar Ray',
        net: -6114,
        total: 6114,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sugar_Ray',
      },
      {
        title: 'Walter Bradford Cannon',
        net: -5989,
        total: 5989,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Walter_Bradford_Cannon',
      },
      {
        title: 'George Stephanopoulos',
        net: -5130,
        total: 5640,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/George_Stephanopoulos',
      },
      {
        title: 'Society for Computation in Psychology',
        net: -4911,
        total: 4911,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Society_for_Computation_in_Psychology',
      },
      {
        title: 'The Maid (2005 film)',
        net: -4263,
        total: 4263,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/The_Maid_(2005_film)',
      },
      {
        title: 'Calibishie',
        net: 3892,
        total: 3892,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Calibishie',
      },
      {
        title: 'Persephone',
        net: -3813,
        total: 3813,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Persephone',
      },
      {
        title: 'FAFSA',
        net: 3608,
        total: 3608,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/FAFSA',
      },
      {
        title: 'Yale University',
        net: -2998,
        total: 2998,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Yale_University',
      },
      {
        title: 'Cognitive dissonance',
        net: 2742,
        total: 2742,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Cognitive_dissonance',
      },
    ],
    unique: [
      {
        title: 'University of California, Merced',
        net: 8887,
        total: 18013,
        unique_editors: 114,
        edits: 195,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Merced',
      },
      {
        title: 'Merced, California',
        net: 666,
        total: 1244,
        unique_editors: 13,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Merced,_California',
      },
      {
        title: 'Talk:University of California, Merced',
        net: -48412,
        total: 50108,
        unique_editors: 9,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Merced',
      },
      {
        title: 'University of California',
        net: 11,
        total: 15,
        unique_editors: 5,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/University_of_California',
      },
      {
        title: 'User talk:Ocatecir',
        net: 2208,
        total: 2208,
        unique_editors: 4,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Ocatecir',
      },
      {
        title: 'Sigma Delta Alpha',
        net: 23,
        total: 225,
        unique_editors: 4,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Sigma_Delta_Alpha',
      },
      {
        title: 'Alan Dawa Dolma',
        net: 12,
        total: 94,
        unique_editors: 4,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Alan_Dawa_Dolma',
      },
      {
        title: 'Scripps Ranch High School',
        net: -186,
        total: 314,
        unique_editors: 3,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Scripps_Ranch_High_School',
      },
      {
        title: 'List of Sigma Alpha Epsilon chapters',
        net: 71,
        total: 91,
        unique_editors: 3,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/List_of_Sigma_Alpha_Epsilon_chapters',
      },
      {
        title: 'Delta Epsilon Mu',
        net: 198,
        total: 224,
        unique_editors: 3,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Delta_Epsilon_Mu',
      },
      {
        title: 'Asuna Kagurazaka',
        net: -1667,
        total: 1667,
        unique_editors: 3,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/List_of_Negima!_Magister_Negi_Magi_characters',
      },
      {
        title: 'Aruba',
        net: 348,
        total: 348,
        unique_editors: 3,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Aruba',
      },
      {
        title: 'Ziad Rahbani',
        net: 201,
        total: 201,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Ziad_Rahbani',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 546,
        total: 546,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Westmoor High School',
        net: 511,
        total: 695,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Westmoor_High_School',
      },
    ],
    edits: [
      {
        title: 'University of California, Merced',
        net: 8887,
        total: 18013,
        unique_editors: 114,
        edits: 195,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Merced',
      },
      {
        title: 'List of Black Clover characters',
        net: 13361,
        total: 13399,
        unique_editors: 2,
        edits: 143,
        urls: 'https://en.wikipedia.org/wiki/List_of_Black_Clover_characters',
      },
      {
        title: 'Jutsu (Naruto)',
        net: 1650,
        total: 1768,
        unique_editors: 2,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Naruto',
      },
      {
        title: 'Merced, California',
        net: 666,
        total: 1244,
        unique_editors: 13,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Merced,_California',
      },
      {
        title: 'Alejandro Saab',
        net: 982,
        total: 1166,
        unique_editors: 1,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Alejandro_Saab',
      },
      {
        title: 'Raymond Chiao',
        net: 1219,
        total: 1233,
        unique_editors: 1,
        edits: 15,
        urls: 'https://en.wikipedia.org/wiki/Raymond_Chiao',
      },
      {
        title: 'Talk:Merced Assembly Center',
        net: 2686,
        total: 2690,
        unique_editors: 2,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/Talk:Merced_Assembly_Center',
      },
      {
        title: 'Talk:University of California, Merced',
        net: -48412,
        total: 50108,
        unique_editors: 9,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Merced',
      },
      {
        title: 'List of Sigma Alpha Epsilon chapters',
        net: 71,
        total: 91,
        unique_editors: 3,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/List_of_Sigma_Alpha_Epsilon_chapters',
      },
      {
        title: 'Westmoor High School',
        net: 511,
        total: 695,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Westmoor_High_School',
      },
      {
        title: 'Lifted Research Group',
        net: 571,
        total: 2079,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Lifted_Research_Group',
      },
      {
        title: 'Soft matter',
        net: 187,
        total: 239,
        unique_editors: 1,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Soft_matter',
      },
      {
        title: 'Alan Dawa Dolma',
        net: 12,
        total: 94,
        unique_editors: 4,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Alan_Dawa_Dolma',
      },
      {
        title: 'University of California',
        net: 11,
        total: 15,
        unique_editors: 5,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/University_of_California',
      },
      {
        title: 'Sigma Delta Alpha',
        net: 23,
        total: 225,
        unique_editors: 4,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Sigma_Delta_Alpha',
      },
    ],
    net_asc: [
      {
        title: 'Talk:University of California, Merced',
        net: -48412,
        total: 50108,
        unique_editors: 9,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Merced',
      },
      {
        title: 'Sugar Ray',
        net: -6114,
        total: 6114,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sugar_Ray',
      },
      {
        title: 'Walter Bradford Cannon',
        net: -5989,
        total: 5989,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Walter_Bradford_Cannon',
      },
      {
        title: 'Snob',
        net: -5936,
        total: 6212,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Snob',
      },
      {
        title: 'George Stephanopoulos',
        net: -5130,
        total: 5640,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/George_Stephanopoulos',
      },
      {
        title: 'Society for Computation in Psychology',
        net: -4911,
        total: 4911,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Society_for_Computation_in_Psychology',
      },
      {
        title: 'The Maid (2005 film)',
        net: -4263,
        total: 4263,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/The_Maid_(2005_film)',
      },
      {
        title: 'Persephone',
        net: -3813,
        total: 3813,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Persephone',
      },
      {
        title: 'Yale University',
        net: -2998,
        total: 2998,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Yale_University',
      },
      {
        title: 'Macquarie University',
        net: -2157,
        total: 2157,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Macquarie_University',
      },
      {
        title: 'University of Oregon',
        net: -1769,
        total: 1769,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/University_of_Oregon',
      },
      {
        title: 'List of Ig Nobel Prize winners',
        net: -1744,
        total: 1744,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/List_of_Ig_Nobel_Prize_winners',
      },
      {
        title: 'San Diego State University',
        net: -1671,
        total: 1671,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/San_Diego_State_University',
      },
      {
        title: 'Asuna Kagurazaka',
        net: -1667,
        total: 1667,
        unique_editors: 3,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/List_of_Negima!_Magister_Negi_Magi_characters',
      },
      {
        title: 'Problematization',
        net: -1655,
        total: 1655,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Problematization',
      },
    ],
  },
  UCOP: {
    net: [
      {
        title: 'Rancho Marino Reserve',
        net: 1984,
        total: 2226,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Rancho_Marino_Reserve',
      },
      {
        title: 'Template talk:Protected areas of California',
        net: 1938,
        total: 1938,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Template_talk:Protected_areas_of_California',
      },
      {
        title: 'Washington University in St. Louis',
        net: 1674,
        total: 1674,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Washington_University_in_St._Louis',
      },
      {
        title: 'The EndUp',
        net: 1508,
        total: 1510,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/The_EndUp',
      },
      {
        title: 'Talk:HTTP cookie',
        net: 1096,
        total: 1096,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:HTTP_cookie',
      },
      {
        title: 'Talk:Tag (metadata)',
        net: 977,
        total: 977,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Tag_(metadata)',
      },
      {
        title: 'LaGuardia Airport',
        net: 916,
        total: 916,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/LaGuardia_Airport',
      },
      {
        title: 'Burns Piñon Ridge Reserve',
        net: 750,
        total: 750,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Burns_Pi%C3%B1on_Ridge_Reserve',
      },
      {
        title: 'Film Quarterly',
        net: 716,
        total: 716,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Film_Quarterly',
      },
      {
        title: 'Wayne Williams',
        net: 655,
        total: 655,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wayne_Williams',
      },
      {
        title: 'Martinez, California',
        net: 559,
        total: 559,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Martinez,_California',
      },
      {
        title: 'List of protests and demonstrations in the United States by size',
        net: 552,
        total: 604,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/List_of_protests_and_demonstrations_in_the_United_States_by_size',
      },
      {
        title: 'Talk:Snoring',
        net: 474,
        total: 474,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Snoring',
      },
      {
        title: 'University of California Natural Reserve System',
        net: 466,
        total: 642,
        unique_editors: 4,
        edits: 13,
        urls: 'https://en.wikipedia.org/wiki/University_of_California_Natural_Reserve_System',
      },
      {
        title: 'King Lear',
        net: 440,
        total: 440,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/King_Lear',
      },
    ],
    total: [
      {
        title: 'Mark Yudof',
        net: -3194,
        total: 7294,
        unique_editors: 2,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Mark_Yudof',
      },
      {
        title: 'Rancho Marino Reserve',
        net: 1984,
        total: 2226,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Rancho_Marino_Reserve',
      },
      {
        title: 'Template talk:Protected areas of California',
        net: 1938,
        total: 1938,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Template_talk:Protected_areas_of_California',
      },
      {
        title: 'Washington University in St. Louis',
        net: 1674,
        total: 1674,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Washington_University_in_St._Louis',
      },
      {
        title: 'The EndUp',
        net: 1508,
        total: 1510,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/The_EndUp',
      },
      {
        title: 'Starship Entertainment',
        net: -1161,
        total: 1161,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Starship_Entertainment',
      },
      {
        title: 'Talk:HTTP cookie',
        net: 1096,
        total: 1096,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:HTTP_cookie',
      },
      {
        title: 'Talk:Tag (metadata)',
        net: 977,
        total: 977,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Tag_(metadata)',
      },
      {
        title: 'Ishtar',
        net: -945,
        total: 945,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Inanna',
      },
      {
        title: 'LaGuardia Airport',
        net: 916,
        total: 916,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/LaGuardia_Airport',
      },
      {
        title: 'Martin Gore',
        net: -827,
        total: 827,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Martin_Gore',
      },
      {
        title: 'Burns Piñon Ridge Reserve',
        net: 750,
        total: 750,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Burns_Pi%C3%B1on_Ridge_Reserve',
      },
      {
        title: 'Film Quarterly',
        net: 716,
        total: 716,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Film_Quarterly',
      },
      {
        title: 'Aquatic Park (Berkeley)',
        net: 400,
        total: 674,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Aquatic_Park_(Berkeley)',
      },
      {
        title: 'Wayne Williams',
        net: 655,
        total: 655,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wayne_Williams',
      },
    ],
    unique: [
      {
        title: 'University of California Natural Reserve System',
        net: 466,
        total: 642,
        unique_editors: 4,
        edits: 13,
        urls: 'https://en.wikipedia.org/wiki/University_of_California_Natural_Reserve_System',
      },
      {
        title: 'Lucena',
        net: 206,
        total: 284,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Lucena',
      },
      {
        title: 'Vallejo, California',
        net: 104,
        total: 104,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Vallejo,_California',
      },
      {
        title: 'The Book of Matt',
        net: 40,
        total: 62,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/The_Book_of_Matt',
      },
      {
        title: 'Santa Cruz Island',
        net: 387,
        total: 387,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Santa_Cruz_Island',
      },
      {
        title: 'Mark Yudof',
        net: -3194,
        total: 7294,
        unique_editors: 2,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Mark_Yudof',
      },
      {
        title: 'List of people associated with the London School of Economics',
        net: 186,
        total: 234,
        unique_editors: 2,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/List_of_people_associated_with_the_London_School_of_Economics',
      },
      {
        title: 'California Digital Library',
        net: 201,
        total: 201,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/California_Digital_Library',
      },
      {
        title: 'CICS',
        net: -19,
        total: 19,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/CICS',
      },
      {
        title: 'Zabriskie Point',
        net: 0,
        total: 0,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Zabriskie_Point',
      },
      {
        title: 'Yenda Thalaiyila Yenna Vekkala',
        net: 0,
        total: 0,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Yenda_Thalaiyila_Yenna_Vekkala',
      },
      {
        title: 'Yayati',
        net: 234,
        total: 434,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Yayati',
      },
      {
        title: 'XTF',
        net: -16,
        total: 16,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/XTF',
      },
      {
        title: 'WordPerfect',
        net: 8,
        total: 8,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/WordPerfect',
      },
      {
        title: 'Winfield, Kansas',
        net: -8,
        total: 8,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Winfield,_Kansas',
      },
    ],
    edits: [
      {
        title: 'Frank McCourt',
        net: 165,
        total: 523,
        unique_editors: 1,
        edits: 15,
        urls: 'https://en.wikipedia.org/wiki/Frank_McCourt',
      },
      {
        title: 'University of California Natural Reserve System',
        net: 466,
        total: 642,
        unique_editors: 4,
        edits: 13,
        urls: 'https://en.wikipedia.org/wiki/University_of_California_Natural_Reserve_System',
      },
      {
        title: 'Wikipedia:Tutorial (historical)/Editing/sandbox',
        net: 183,
        total: 287,
        unique_editors: 1,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Yayati',
        net: 234,
        total: 434,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Yayati',
      },
      {
        title: 'The EndUp',
        net: 1508,
        total: 1510,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/The_EndUp',
      },
      {
        title: 'List of people associated with the London School of Economics',
        net: 186,
        total: 234,
        unique_editors: 2,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/List_of_people_associated_with_the_London_School_of_Economics',
      },
      {
        title: 'Mark Yudof',
        net: -3194,
        total: 7294,
        unique_editors: 2,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Mark_Yudof',
      },
      {
        title: 'Lucena',
        net: 206,
        total: 284,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Lucena',
      },
      {
        title: 'Conguillío National Park',
        net: 4,
        total: 44,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Conguill%C3%ADo_National_Park',
      },
      {
        title: 'Washington University in St. Louis',
        net: 1674,
        total: 1674,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Washington_University_in_St._Louis',
      },
      {
        title: 'Rancho Marino Reserve',
        net: 1984,
        total: 2226,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Rancho_Marino_Reserve',
      },
      {
        title: 'Min Jin Lee',
        net: 51,
        total: 51,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Min_Jin_Lee',
      },
      {
        title: 'List of protests and demonstrations in the United States by size',
        net: 552,
        total: 604,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/List_of_protests_and_demonstrations_in_the_United_States_by_size',
      },
      {
        title: 'King Lear',
        net: 440,
        total: 440,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/King_Lear',
      },
      {
        title: 'Guy de La Brosse',
        net: 145,
        total: 203,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Guy_de_La_Brosse',
      },
    ],
    net_asc: [
      {
        title: 'Mark Yudof',
        net: -3194,
        total: 7294,
        unique_editors: 2,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Mark_Yudof',
      },
      {
        title: 'Starship Entertainment',
        net: -1161,
        total: 1161,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Starship_Entertainment',
      },
      {
        title: 'Ishtar',
        net: -945,
        total: 945,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Inanna',
      },
      {
        title: 'Martin Gore',
        net: -827,
        total: 827,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Martin_Gore',
      },
      {
        title: 'MVS',
        net: -304,
        total: 304,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/MVS',
      },
      {
        title: 'Andrea Kelly',
        net: -264,
        total: 264,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Andrea_Kelly',
      },
      {
        title: 'Paris Is Burning (film)',
        net: -209,
        total: 209,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Paris_Is_Burning_(film)',
      },
      {
        title: 'University of California',
        net: -202,
        total: 202,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/University_of_California',
      },
      {
        title: 'Happy Meal',
        net: -193,
        total: 193,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Happy_Meal',
      },
      {
        title: 'Stewardship',
        net: -190,
        total: 190,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Stewardship',
      },
      {
        title: 'Time Sharing Option',
        net: -184,
        total: 184,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Time_Sharing_Option',
      },
      {
        title: 'List of programming languages by type',
        net: -172,
        total: 172,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/List_of_programming_languages_by_type',
      },
      {
        title: 'Angelo Garcia',
        net: -166,
        total: 166,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Angelo_Garcia',
      },
      {
        title: 'Battlecruiser',
        net: -163,
        total: 163,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Battlecruiser',
      },
      {
        title: 'New Model Army',
        net: -161,
        total: 161,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/New_Model_Army',
      },
    ],
  },
  UCR: {
    net: [
      {
        title: 'Mighty Morphin Power Rangers',
        net: 32658,
        total: 32658,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Mighty_Morphin_Power_Rangers',
      },
      {
        title: 'Metz',
        net: 22303,
        total: 30969,
        unique_editors: 6,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Metz',
      },
      {
        title: 'File system',
        net: 19807,
        total: 19807,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/File_system',
      },
      {
        title: 'Talk:Tori Amos',
        net: 16267,
        total: 16267,
        unique_editors: 4,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Talk:Tori_Amos',
      },
      {
        title: 'Santiago Canyon Fire',
        net: 13026,
        total: 13026,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Santiago_Canyon_Fire',
      },
      {
        title: 'Mooretown Rancheria of Maidu Indians',
        net: 12728,
        total: 12752,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Mooretown_Rancheria_of_Maidu_Indians',
      },
      {
        title: '2006 in film',
        net: 11803,
        total: 11807,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/2006_in_film',
      },
      {
        title: 'List of NFL Coach of the Year awards',
        net: 11753,
        total: 16167,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/List_of_NFL_Coach_of_the_Year_awards',
      },
      {
        title: 'Talk:University of California, Riverside',
        net: 11572,
        total: 14908,
        unique_editors: 7,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Riverside',
      },
      {
        title: 'Mega Man Zero',
        net: 11288,
        total: 11288,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Mega_Man_Zero',
      },
      {
        title: 'Lambda Phi Epsilon',
        net: 10016,
        total: 11584,
        unique_editors: 4,
        edits: 15,
        urls: 'https://en.wikipedia.org/wiki/Lambda_Phi_Epsilon',
      },
      {
        title: 'Talk:Apologize (song)',
        net: 9187,
        total: 9191,
        unique_editors: 4,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/Talk:Apologize_(song)',
      },
      {
        title: 'Sandstone',
        net: 9140,
        total: 9140,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Sandstone',
      },
      {
        title: 'Primetime Emmy Award for Outstanding Lead Actor in a Comedy Series',
        net: 7822,
        total: 8582,
        unique_editors: 1,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/Primetime_Emmy_Award_for_Outstanding_Lead_Actor_in_a_Comedy_Series',
      },
      {
        title: 'Wikipedia:WikiProject Articles requested for more than a year',
        net: 6762,
        total: 6762,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:WikiProject_Articles_requested_for_more_than_a_year',
      },
    ],
    total: [
      {
        title: 'David Hume',
        net: -63264,
        total: 63270,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/David_Hume',
      },
      {
        title: '613 commandments',
        net: -61527,
        total: 61529,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/613_commandments',
      },
      {
        title: 'Superman',
        net: -49690,
        total: 49690,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Superman',
      },
      {
        title: 'Albert Einstein',
        net: -45684,
        total: 45684,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Albert_Einstein',
      },
      {
        title: 'Same-sex marriage',
        net: -44848,
        total: 44848,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Same-sex_marriage',
      },
      {
        title: 'John McCain',
        net: -44010,
        total: 44398,
        unique_editors: 2,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/John_McCain',
      },
      {
        title: 'George W. Bush',
        net: -43735,
        total: 43999,
        unique_editors: 3,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/George_W._Bush',
      },
      {
        title: 'One Missed Call (2003 film)',
        net: -36459,
        total: 42133,
        unique_editors: 3,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/One_Missed_Call_(2003_film)',
      },
      {
        title: 'Möbius transformation',
        net: -36690,
        total: 37112,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/M%C3%B6bius_transformation',
      },
      {
        title: 'Mighty Morphin Power Rangers',
        net: 32658,
        total: 32658,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Mighty_Morphin_Power_Rangers',
      },
      {
        title: '59th Primetime Emmy Awards',
        net: 5000,
        total: 31506,
        unique_editors: 4,
        edits: 34,
        urls: 'https://en.wikipedia.org/wiki/59th_Primetime_Emmy_Awards',
      },
      {
        title: 'Utah',
        net: -30993,
        total: 30993,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Utah',
      },
      {
        title: 'Metz',
        net: 22303,
        total: 30969,
        unique_editors: 6,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Metz',
      },
      {
        title: 'Final Destination (film)',
        net: -23338,
        total: 23338,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Final_Destination_(film)',
      },
      {
        title: 'List of Kyle XY episodes',
        net: -23039,
        total: 23039,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Kyle_XY_episodes',
      },
    ],
    unique: [
      {
        title: 'University of California, Riverside',
        net: -2731,
        total: 18745,
        unique_editors: 59,
        edits: 149,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Riverside',
      },
      {
        title: 'List of oldest living people',
        net: -723,
        total: 1563,
        unique_editors: 11,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/List_of_oldest_living_people',
      },
      {
        title: 'Wikipedia:Meetup/Riverside/WLL/2013',
        net: 437,
        total: 831,
        unique_editors: 9,
        edits: 29,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Meetup/Riverside/WLL/2013',
      },
      {
        title: 'Charles Evered',
        net: 164,
        total: 978,
        unique_editors: 9,
        edits: 21,
        urls: 'https://en.wikipedia.org/wiki/Charles_Evered',
      },
      {
        title: 'Theodore Garland Jr.',
        net: 5528,
        total: 5616,
        unique_editors: 8,
        edits: 38,
        urls: 'https://en.wikipedia.org/wiki/Theodore_Garland_Jr.',
      },
      {
        title: 'Talk:University of California, Riverside',
        net: 11572,
        total: 14908,
        unique_editors: 7,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Riverside',
      },
      {
        title: 'Volleyball variations',
        net: 692,
        total: 1966,
        unique_editors: 6,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Volleyball_variations',
      },
      {
        title: 'Riverside, California',
        net: 646,
        total: 646,
        unique_editors: 6,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Riverside,_California',
      },
      {
        title: 'Metz',
        net: 22303,
        total: 30969,
        unique_editors: 6,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Metz',
      },
      {
        title: 'Jess Nevins',
        net: 553,
        total: 733,
        unique_editors: 6,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/Jess_Nevins',
      },
      {
        title: 'Garrison Keillor',
        net: 1444,
        total: 1490,
        unique_editors: 6,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/Garrison_Keillor',
      },
      {
        title: 'Evolutionary physiology',
        net: 3613,
        total: 3721,
        unique_editors: 6,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/Evolutionary_physiology',
      },
      {
        title: 'Apologize (song)',
        net: -1071,
        total: 1363,
        unique_editors: 6,
        edits: 13,
        urls: 'https://en.wikipedia.org/wiki/Apologize_(song)',
      },
      {
        title: 'Wikipedia:Introduction (historical)',
        net: 189,
        total: 203,
        unique_editors: 5,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Introduction_(historical)',
      },
      {
        title: 'Silent Hill (film)',
        net: -5400,
        total: 5400,
        unique_editors: 5,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Silent_Hill_(film)',
      },
    ],
    edits: [
      {
        title: 'University of California, Riverside',
        net: -2731,
        total: 18745,
        unique_editors: 59,
        edits: 149,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Riverside',
      },
      {
        title: 'Metz',
        net: 22303,
        total: 30969,
        unique_editors: 6,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Metz',
      },
      {
        title: '2007 in film',
        net: 2655,
        total: 2789,
        unique_editors: 4,
        edits: 47,
        urls: 'https://en.wikipedia.org/wiki/2007_in_film',
      },
      {
        title: 'Evolutionary physiology',
        net: 3613,
        total: 3721,
        unique_editors: 6,
        edits: 42,
        urls: 'https://en.wikipedia.org/wiki/Evolutionary_physiology',
      },
      {
        title: '80th Academy Awards',
        net: -11459,
        total: 20727,
        unique_editors: 2,
        edits: 41,
        urls: 'https://en.wikipedia.org/wiki/80th_Academy_Awards',
      },
      {
        title: 'Theodore Garland Jr.',
        net: 5528,
        total: 5616,
        unique_editors: 8,
        edits: 38,
        urls: 'https://en.wikipedia.org/wiki/Theodore_Garland_Jr.',
      },
      {
        title: '59th Primetime Emmy Awards',
        net: 5000,
        total: 31506,
        unique_editors: 4,
        edits: 34,
        urls: 'https://en.wikipedia.org/wiki/59th_Primetime_Emmy_Awards',
      },
      {
        title: 'Got Milk?',
        net: -128,
        total: 3066,
        unique_editors: 2,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/Got_Milk%3F',
      },
      {
        title: 'Efforts to impeach George W. Bush',
        net: 3803,
        total: 7809,
        unique_editors: 3,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/Efforts_to_impeach_George_W._Bush',
      },
      {
        title: 'Talk:University of California, Riverside',
        net: 11572,
        total: 14908,
        unique_editors: 7,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Riverside',
      },
      {
        title: 'List of Primetime Emmy Awards ceremonies',
        net: 6029,
        total: 6371,
        unique_editors: 2,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/List_of_Primetime_Emmy_Awards_ceremonies',
      },
      {
        title: '2008 in film',
        net: -703,
        total: 7185,
        unique_editors: 2,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/2008_in_film',
      },
      {
        title: 'Wikipedia:Meetup/Riverside/WLL/2013',
        net: 437,
        total: 831,
        unique_editors: 9,
        edits: 29,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Meetup/Riverside/WLL/2013',
      },
      {
        title: 'Garrison Keillor',
        net: 1444,
        total: 1490,
        unique_editors: 6,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/Garrison_Keillor',
      },
      {
        title: 'List of PBS logos',
        net: 1001,
        total: 1167,
        unique_editors: 3,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/PBS',
      },
    ],
    net_asc: [
      {
        title: 'David Hume',
        net: -63264,
        total: 63270,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/David_Hume',
      },
      {
        title: '613 commandments',
        net: -61527,
        total: 61529,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/613_commandments',
      },
      {
        title: 'Superman',
        net: -49690,
        total: 49690,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Superman',
      },
      {
        title: 'Albert Einstein',
        net: -45684,
        total: 45684,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Albert_Einstein',
      },
      {
        title: 'Same-sex marriage',
        net: -44848,
        total: 44848,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Same-sex_marriage',
      },
      {
        title: 'John McCain',
        net: -44010,
        total: 44398,
        unique_editors: 2,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/John_McCain',
      },
      {
        title: 'George W. Bush',
        net: -43735,
        total: 43999,
        unique_editors: 3,
        edits: 10,
        urls: 'https://en.wikipedia.org/wiki/George_W._Bush',
      },
      {
        title: 'Möbius transformation',
        net: -36690,
        total: 37112,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/M%C3%B6bius_transformation',
      },
      {
        title: 'One Missed Call (2003 film)',
        net: -36459,
        total: 42133,
        unique_editors: 3,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/One_Missed_Call_(2003_film)',
      },
      {
        title: 'Utah',
        net: -30993,
        total: 30993,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Utah',
      },
      {
        title: 'Final Destination (film)',
        net: -23338,
        total: 23338,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Final_Destination_(film)',
      },
      {
        title: 'List of Kyle XY episodes',
        net: -23039,
        total: 23039,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Kyle_XY_episodes',
      },
      {
        title: 'Flavor Flav',
        net: -19036,
        total: 19036,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Flavor_Flav',
      },
      {
        title: 'Grand Theft Auto V',
        net: -17473,
        total: 17473,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Grand_Theft_Auto_V',
      },
      {
        title: 'Massey Ferguson',
        net: -17146,
        total: 17146,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Massey_Ferguson',
      },
    ],
  },
  UCSB: {
    net: [
      {
        title: 'User:Infrogmation',
        net: 788778,
        total: 788778,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:Infrogmation',
      },
      {
        title: 'Talk:Antifeminism',
        net: 60784,
        total: 61202,
        unique_editors: 11,
        edits: 134,
        urls: 'https://en.wikipedia.org/wiki/Talk:Antifeminism',
      },
      {
        title: 'Talk:Control of cities during the Syrian civil war',
        net: 42051,
        total: 46821,
        unique_editors: 49,
        edits: 133,
        urls: 'https://en.wikipedia.org/wiki/Talk:Control_of_cities_during_the_Syrian_civil_war',
      },
      {
        title: 'Talk:Misandry',
        net: 40341,
        total: 40347,
        unique_editors: 10,
        edits: 39,
        urls: 'https://en.wikipedia.org/wiki/Talk:Misandry',
      },
      {
        title: 'Patriotic Spring',
        net: 39230,
        total: 39464,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Neo-nationalism',
      },
      {
        title: 'Talk:Incest',
        net: 38443,
        total: 38851,
        unique_editors: 7,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/Talk:Incest',
      },
      {
        title: 'Talk:An Exceptionally Simple Theory of Everything',
        net: 35822,
        total: 35822,
        unique_editors: 2,
        edits: 22,
        urls: 'https://en.wikipedia.org/wiki/Talk:An_Exceptionally_Simple_Theory_of_Everything',
      },
      {
        title: 'Outlast',
        net: 33517,
        total: 33707,
        unique_editors: 11,
        edits: 24,
        urls: 'https://en.wikipedia.org/wiki/Outlast',
      },
      {
        title: 'Survivor (American TV series)',
        net: 28159,
        total: 28287,
        unique_editors: 16,
        edits: 25,
        urls: 'https://en.wikipedia.org/wiki/Survivor_(American_TV_series)',
      },
      {
        title: 'Ben Carson 2016 presidential campaign',
        net: 25434,
        total: 45058,
        unique_editors: 19,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Ben_Carson_2016_presidential_campaign',
      },
      {
        title: '2016 Republican Party presidential primaries',
        net: 24329,
        total: 42735,
        unique_editors: 28,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/2016_Republican_Party_presidential_primaries',
      },
      {
        title: 'Harry Potter and the Chamber of Secrets (film)',
        net: 23759,
        total: 23759,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Harry_Potter_and_the_Chamber_of_Secrets_(film)',
      },
      {
        title: 'Wikipedia talk:WikiProject Gender studies',
        net: 23268,
        total: 24236,
        unique_editors: 4,
        edits: 65,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia_talk:WikiProject_Gender_studies',
      },
      {
        title: 'List of The Walking Dead (TV series) characters',
        net: 22303,
        total: 22383,
        unique_editors: 17,
        edits: 33,
        urls: 'https://en.wikipedia.org/wiki/List_of_The_Walking_Dead_(TV_series)_characters',
      },
      {
        title: 'Talk:Excommunication',
        net: 20916,
        total: 20922,
        unique_editors: 6,
        edits: 14,
        urls: 'https://en.wikipedia.org/wiki/Talk:Excommunication',
      },
    ],
    total: [
      {
        title: 'User:Infrogmation',
        net: 788778,
        total: 788778,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:Infrogmation',
      },
      {
        title: 'Bertrand Russell',
        net: -101483,
        total: 101483,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Bertrand_Russell',
      },
      {
        title: 'Republican Party (United States)',
        net: -78958,
        total: 78958,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Republican_Party_(United_States)',
      },
      {
        title: 'Incest',
        net: 7141,
        total: 72471,
        unique_editors: 8,
        edits: 120,
        urls: 'https://en.wikipedia.org/wiki/Incest',
      },
      {
        title: 'University of California, Santa Barbara',
        net: 12652,
        total: 64318,
        unique_editors: 166,
        edits: 324,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Barbara',
      },
      {
        title: 'Uranium',
        net: -64170,
        total: 64170,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Uranium',
      },
      {
        title: 'Talk:Antifeminism',
        net: 60784,
        total: 61202,
        unique_editors: 11,
        edits: 134,
        urls: 'https://en.wikipedia.org/wiki/Talk:Antifeminism',
      },
      {
        title: 'Muqtada al-Sadr',
        net: 1,
        total: 58009,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Muqtada_al-Sadr',
      },
      {
        title: 'Y',
        net: -54656,
        total: 54656,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Y',
      },
      {
        title: 'Cain and Abel',
        net: -47273,
        total: 47273,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Cain_and_Abel',
      },
      {
        title: 'Suleiman the Magnificent',
        net: -46910,
        total: 46910,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Suleiman_the_Magnificent',
      },
      {
        title: 'Talk:Control of cities during the Syrian civil war',
        net: 42051,
        total: 46821,
        unique_editors: 49,
        edits: 133,
        urls: 'https://en.wikipedia.org/wiki/Talk:Control_of_cities_during_the_Syrian_civil_war',
      },
      {
        title: 'Ben Carson 2016 presidential campaign',
        net: 25434,
        total: 45058,
        unique_editors: 19,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Ben_Carson_2016_presidential_campaign',
      },
      {
        title: 'Guatemala',
        net: -43233,
        total: 43233,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Guatemala',
      },
      {
        title: '2016 Republican Party presidential primaries',
        net: 24329,
        total: 42735,
        unique_editors: 28,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/2016_Republican_Party_presidential_primaries',
      },
    ],
    unique: [
      {
        title: 'University of California, Santa Barbara',
        net: 12652,
        total: 64318,
        unique_editors: 166,
        edits: 324,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Barbara',
      },
      {
        title: 'Extravaganza (music festival)',
        net: 934,
        total: 6456,
        unique_editors: 64,
        edits: 154,
        urls: 'https://en.wikipedia.org/wiki/Extravaganza_(music_festival)',
      },
      {
        title: 'Talk:Control of cities during the Syrian civil war',
        net: 42051,
        total: 46821,
        unique_editors: 49,
        edits: 133,
        urls: 'https://en.wikipedia.org/wiki/Talk:Control_of_cities_during_the_Syrian_civil_war',
      },
      {
        title: 'Wikipedia:Tutorial (historical)/Editing/sandbox',
        net: 5392,
        total: 7188,
        unique_editors: 36,
        edits: 77,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'User:Tibouchina',
        net: 1490,
        total: 4284,
        unique_editors: 31,
        edits: 66,
        urls: 'https://en.wikipedia.org/wiki/User:Tibouchina',
      },
      {
        title: 'Isla Vista, California',
        net: -5202,
        total: 12376,
        unique_editors: 29,
        edits: 43,
        urls: 'https://en.wikipedia.org/wiki/Isla_Vista,_California',
      },
      {
        title: '2016 Republican Party presidential primaries',
        net: 24329,
        total: 42735,
        unique_editors: 28,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/2016_Republican_Party_presidential_primaries',
      },
      {
        title: 'Santa Catalina Dorms',
        net: 599,
        total: 5557,
        unique_editors: 26,
        edits: 43,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Barbara',
      },
      {
        title: '2014 United States Senate elections',
        net: 2920,
        total: 5618,
        unique_editors: 26,
        edits: 38,
        urls: 'https://en.wikipedia.org/wiki/2014_United_States_Senate_elections',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: -1605,
        total: 4993,
        unique_editors: 24,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Survivor: Cagayan',
        net: 10097,
        total: 10745,
        unique_editors: 22,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/Survivor:_Cagayan',
      },
      {
        title: 'Andy Vidak',
        net: 6851,
        total: 6899,
        unique_editors: 22,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/Andy_Vidak',
      },
      {
        title: 'Ben Carson',
        net: 10836,
        total: 11994,
        unique_editors: 20,
        edits: 30,
        urls: 'https://en.wikipedia.org/wiki/Ben_Carson',
      },
      {
        title: 'David Valadao',
        net: 6168,
        total: 6174,
        unique_editors: 19,
        edits: 29,
        urls: 'https://en.wikipedia.org/wiki/David_Valadao',
      },
      {
        title: 'Ben Carson 2016 presidential campaign',
        net: 25434,
        total: 45058,
        unique_editors: 19,
        edits: 50,
        urls: 'https://en.wikipedia.org/wiki/Ben_Carson_2016_presidential_campaign',
      },
    ],
    edits: [
      {
        title: 'University of California, Santa Barbara',
        net: 12652,
        total: 64318,
        unique_editors: 166,
        edits: 324,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Barbara',
      },
      {
        title: 'Extravaganza (music festival)',
        net: 934,
        total: 6456,
        unique_editors: 64,
        edits: 154,
        urls: 'https://en.wikipedia.org/wiki/Extravaganza_(music_festival)',
      },
      {
        title: 'List of Danzan-ryū techniques',
        net: 7995,
        total: 24471,
        unique_editors: 2,
        edits: 138,
        urls: 'https://en.wikipedia.org/wiki/List_of_Danzan-ry%C5%AB_techniques',
      },
      {
        title: 'Excommunication',
        net: 9868,
        total: 11936,
        unique_editors: 5,
        edits: 135,
        urls: 'https://en.wikipedia.org/wiki/Excommunication',
      },
      {
        title: 'Talk:Antifeminism',
        net: 60784,
        total: 61202,
        unique_editors: 11,
        edits: 134,
        urls: 'https://en.wikipedia.org/wiki/Talk:Antifeminism',
      },
      {
        title: 'Talk:Control of cities during the Syrian civil war',
        net: 42051,
        total: 46821,
        unique_editors: 49,
        edits: 133,
        urls: 'https://en.wikipedia.org/wiki/Talk:Control_of_cities_during_the_Syrian_civil_war',
      },
      {
        title: 'User:Chrono1200sphere/sandbox/Acoustic camera',
        net: 11674,
        total: 31330,
        unique_editors: 9,
        edits: 127,
        urls: 'https://en.wikipedia.org/wiki/User:Chrono1200sphere/sandbox/Acoustic_camera',
      },
      {
        title: 'Incest',
        net: 7141,
        total: 72471,
        unique_editors: 8,
        edits: 120,
        urls: 'https://en.wikipedia.org/wiki/Incest',
      },
      {
        title: 'User:Wasabifire/Body Kit',
        net: 3589,
        total: 9871,
        unique_editors: 5,
        edits: 102,
        urls: 'https://en.wikipedia.org/wiki/User:Wasabifire/Body_Kit',
      },
      {
        title: 'John Warwick Montgomery',
        net: 7843,
        total: 17789,
        unique_editors: 18,
        edits: 99,
        urls: 'https://en.wikipedia.org/wiki/John_Warwick_Montgomery',
      },
      {
        title: 'Shunning',
        net: 5552,
        total: 9500,
        unique_editors: 10,
        edits: 91,
        urls: 'https://en.wikipedia.org/wiki/Shunning',
      },
      {
        title: 'Rape',
        net: 9548,
        total: 11336,
        unique_editors: 13,
        edits: 86,
        urls: 'https://en.wikipedia.org/wiki/Rape',
      },
      {
        title: 'Wikipedia:Tutorial (historical)/Editing/sandbox',
        net: 5392,
        total: 7188,
        unique_editors: 36,
        edits: 77,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'List of University of California, Santa Barbara alumni',
        net: 344,
        total: 3728,
        unique_editors: 16,
        edits: 75,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Santa_Barbara_alumni',
      },
      {
        title: 'Child sexual abuse',
        net: 7437,
        total: 7769,
        unique_editors: 3,
        edits: 71,
        urls: 'https://en.wikipedia.org/wiki/Child_sexual_abuse',
      },
    ],
    net_asc: [
      {
        title: 'Bertrand Russell',
        net: -101483,
        total: 101483,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Bertrand_Russell',
      },
      {
        title: 'Republican Party (United States)',
        net: -78958,
        total: 78958,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Republican_Party_(United_States)',
      },
      {
        title: 'Uranium',
        net: -64170,
        total: 64170,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Uranium',
      },
      {
        title: 'Y',
        net: -54656,
        total: 54656,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Y',
      },
      {
        title: 'Cain and Abel',
        net: -47273,
        total: 47273,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Cain_and_Abel',
      },
      {
        title: 'Suleiman the Magnificent',
        net: -46910,
        total: 46910,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Suleiman_the_Magnificent',
      },
      {
        title: 'Guatemala',
        net: -43233,
        total: 43233,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Guatemala',
      },
      {
        title: 'Cucumber',
        net: -42544,
        total: 42544,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Cucumber',
      },
      {
        title: 'Marshall Plan',
        net: -41980,
        total: 41980,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Marshall_Plan',
      },
      {
        title: 'Russia',
        net: -38222,
        total: 38222,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Russia',
      },
      {
        title: 'Mexico',
        net: -37726,
        total: 37726,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Mexico',
      },
      {
        title: 'Salt',
        net: -35187,
        total: 38701,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Salt',
      },
      {
        title: 'Organic chemistry',
        net: -32675,
        total: 32685,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Organic_chemistry',
      },
      {
        title: 'Parminder Nagra',
        net: -31074,
        total: 31074,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Parminder_Nagra',
      },
      {
        title: 'Pien tze huang',
        net: -28163,
        total: 28163,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Pien_tze_huang',
      },
    ],
  },
  UCSC: {
    net: [
      {
        title: 'User talk:169.233.9.97',
        net: 198794,
        total: 202278,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/User_talk:169.233.9.97',
      },
      {
        title: 'List of Naruto characters',
        net: 91795,
        total: 96221,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Naruto_characters',
      },
      {
        title: 'Benjamin H. Freedman',
        net: 74118,
        total: 77138,
        unique_editors: 3,
        edits: 27,
        urls: 'https://en.wikipedia.org/wiki/Benjamin_H._Freedman',
      },
      {
        title: 'Douglas Reed',
        net: 71203,
        total: 77481,
        unique_editors: 6,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Douglas_Reed',
      },
      {
        title: 'Talk:Jewish Bolshevism',
        net: 51058,
        total: 67976,
        unique_editors: 7,
        edits: 15,
        urls: 'https://en.wikipedia.org/wiki/Talk:Jewish_Bolshevism',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33117,
        total: 39697,
        unique_editors: 38,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Pavel Cherenkov',
        net: 32988,
        total: 71406,
        unique_editors: 3,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Pavel_Cherenkov',
      },
      {
        title: 'Sigmund Freud',
        net: 32119,
        total: 32139,
        unique_editors: 4,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Sigmund_Freud',
      },
      {
        title: 'Nancy Grace',
        net: 31642,
        total: 31642,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Nancy_Grace',
      },
      {
        title: 'Two-Face',
        net: 29630,
        total: 29906,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Two-Face',
      },
      {
        title: 'Chip Berlet',
        net: 25863,
        total: 26057,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Chip_Berlet',
      },
      {
        title: 'List of Scientologists',
        net: 23036,
        total: 23036,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/List_of_Scientologists',
      },
      {
        title: 'Barry Zito',
        net: 19749,
        total: 19749,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Barry_Zito',
      },
      {
        title: 'Talk:Conspiracy theory',
        net: 19224,
        total: 19252,
        unique_editors: 2,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Talk:Conspiracy_theory',
      },
      {
        title: 'Richard Lynn',
        net: 18280,
        total: 19194,
        unique_editors: 1,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Richard_Lynn',
      },
    ],
    total: [
      {
        title: 'User talk:DragonflySixtyseven',
        net: -328276,
        total: 328276,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User_talk:DragonflySixtyseven',
      },
      {
        title: "Wikipedia:Administrators' noticeboard/Incidents",
        net: -308522,
        total: 308522,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Administrators%27_noticeboard/Incidents',
      },
      {
        title: 'Yu-Gi-Oh! Trading Card Game',
        net: -52925,
        total: 266691,
        unique_editors: 3,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/Yu-Gi-Oh!_Trading_Card_Game',
      },
      {
        title: 'User talk:169.233.9.97',
        net: 198794,
        total: 202278,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/User_talk:169.233.9.97',
      },
      {
        title: 'Violet (color)',
        net: -142507,
        total: 142507,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Violet_(color)',
      },
      {
        title: 'Oakland, California',
        net: -99822,
        total: 102972,
        unique_editors: 5,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Oakland,_California',
      },
      {
        title: 'List of Naruto characters',
        net: 91795,
        total: 96221,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Naruto_characters',
      },
      {
        title: 'Ireland',
        net: -91189,
        total: 91189,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Ireland',
      },
      {
        title: 'J. Robert Oppenheimer',
        net: -84848,
        total: 84884,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/J._Robert_Oppenheimer',
      },
      {
        title: 'User talk:169.233.115.203',
        net: 15933,
        total: 84425,
        unique_editors: 1,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/User_talk:169.233.115.203',
      },
      {
        title: 'Douglas Reed',
        net: 71203,
        total: 77481,
        unique_editors: 6,
        edits: 18,
        urls: 'https://en.wikipedia.org/wiki/Douglas_Reed',
      },
      {
        title: 'Benjamin H. Freedman',
        net: 74118,
        total: 77138,
        unique_editors: 3,
        edits: 27,
        urls: 'https://en.wikipedia.org/wiki/Benjamin_H._Freedman',
      },
      {
        title: 'Pavel Cherenkov',
        net: 32988,
        total: 71406,
        unique_editors: 3,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Pavel_Cherenkov',
      },
      {
        title: 'Talk:Jewish Bolshevism',
        net: 51058,
        total: 67976,
        unique_editors: 7,
        edits: 15,
        urls: 'https://en.wikipedia.org/wiki/Talk:Jewish_Bolshevism',
      },
      {
        title: 'NBC',
        net: -65233,
        total: 65233,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/NBC',
      },
    ],
    unique: [
      {
        title: 'University of California, Santa Cruz',
        net: 9519,
        total: 14281,
        unique_editors: 112,
        edits: 168,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Cruz',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33117,
        total: 39697,
        unique_editors: 38,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Fish Rap Live!',
        net: 3317,
        total: 4701,
        unique_editors: 30,
        edits: 59,
        urls: 'https://en.wikipedia.org/wiki/Fish_Rap_Live!',
      },
      {
        title: 'Santa Cruz, California',
        net: 980,
        total: 1636,
        unique_editors: 21,
        edits: 25,
        urls: 'https://en.wikipedia.org/wiki/Santa_Cruz,_California',
      },
      {
        title: 'Cowell College',
        net: 75,
        total: 7161,
        unique_editors: 21,
        edits: 29,
        urls: 'https://en.wikipedia.org/wiki/Cowell_College',
      },
      {
        title: 'California State Route 85',
        net: 2832,
        total: 3520,
        unique_editors: 21,
        edits: 41,
        urls: 'https://en.wikipedia.org/wiki/California_State_Route_85',
      },
      {
        title: 'Steve Whittaker',
        net: 647,
        total: 1077,
        unique_editors: 20,
        edits: 36,
        urls: 'https://en.wikipedia.org/wiki/Steve_Whittaker',
      },
      {
        title: 'Theta Chi',
        net: 647,
        total: 857,
        unique_editors: 18,
        edits: 34,
        urls: 'https://en.wikipedia.org/wiki/Theta_Chi',
      },
      {
        title: 'List of University of California, Santa Cruz people',
        net: 746,
        total: 2228,
        unique_editors: 17,
        edits: 32,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_Santa_Cruz_people',
      },
      {
        title: 'GMA Life TV',
        net: -308,
        total: 2574,
        unique_editors: 16,
        edits: 29,
        urls: 'https://en.wikipedia.org/wiki/GMA_Life_TV',
      },
      {
        title: 'Darrell Long',
        net: 1406,
        total: 1730,
        unique_editors: 15,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Darrell_Long',
      },
      {
        title: 'City on a Hill Press',
        net: 1133,
        total: 2597,
        unique_editors: 14,
        edits: 23,
        urls: 'https://en.wikipedia.org/wiki/City_on_a_Hill_Press',
      },
      {
        title: 'Merrill College',
        net: 695,
        total: 873,
        unique_editors: 13,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/Merrill_College',
      },
      {
        title: 'Kresge College',
        net: 1191,
        total: 2091,
        unique_editors: 13,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Kresge_College',
      },
      {
        title: 'Crown College, University of California, Santa Cruz',
        net: 987,
        total: 1463,
        unique_editors: 13,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/Crown_College,_University_of_California,_Santa_Cruz',
      },
    ],
    edits: [
      {
        title: 'University of California, Santa Cruz',
        net: 9519,
        total: 14281,
        unique_editors: 112,
        edits: 168,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Santa_Cruz',
      },
      {
        title: 'Monterey Motorsports Reunion',
        net: -2648,
        total: 12202,
        unique_editors: 10,
        edits: 123,
        urls: 'https://en.wikipedia.org/wiki/Monterey_Motorsports_Reunion',
      },
      {
        title: 'GT World Challenge America',
        net: -825,
        total: 8229,
        unique_editors: 5,
        edits: 86,
        urls: 'https://en.wikipedia.org/wiki/GT_World_Challenge_America',
      },
      {
        title: 'Wikipedia:Tutorial (historical)/Formatting/sandbox',
        net: 17542,
        total: 27012,
        unique_editors: 6,
        edits: 84,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Tutorial_(historical)/Formatting/sandbox',
      },
      {
        title: 'Music Choice',
        net: -3519,
        total: 7715,
        unique_editors: 3,
        edits: 75,
        urls: 'https://en.wikipedia.org/wiki/Music_Choice',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33117,
        total: 39697,
        unique_editors: 38,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Heruli',
        net: -32618,
        total: 56446,
        unique_editors: 5,
        edits: 62,
        urls: 'https://en.wikipedia.org/wiki/Heruli',
      },
      {
        title: 'Fish Rap Live!',
        net: 3317,
        total: 4701,
        unique_editors: 30,
        edits: 59,
        urls: 'https://en.wikipedia.org/wiki/Fish_Rap_Live!',
      },
      {
        title: 'Eustace Mullins',
        net: 16058,
        total: 22134,
        unique_editors: 9,
        edits: 57,
        urls: 'https://en.wikipedia.org/wiki/Eustace_Mullins',
      },
      {
        title: 'List of deleted state highways in California',
        net: 4059,
        total: 9393,
        unique_editors: 10,
        edits: 44,
        urls: 'https://en.wikipedia.org/wiki/List_of_deleted_state_highways_in_California',
      },
      {
        title: 'California State Route 85',
        net: 2832,
        total: 3520,
        unique_editors: 21,
        edits: 41,
        urls: 'https://en.wikipedia.org/wiki/California_State_Route_85',
      },
      {
        title: 'Cantonese opera',
        net: 1179,
        total: 1459,
        unique_editors: 1,
        edits: 38,
        urls: 'https://en.wikipedia.org/wiki/Cantonese_opera',
      },
      {
        title: 'Trans-Am Series',
        net: 2001,
        total: 2897,
        unique_editors: 3,
        edits: 36,
        urls: 'https://en.wikipedia.org/wiki/Trans-Am_Series',
      },
      {
        title: 'Steve Whittaker',
        net: 647,
        total: 1077,
        unique_editors: 20,
        edits: 36,
        urls: 'https://en.wikipedia.org/wiki/Steve_Whittaker',
      },
      {
        title: 'Homestar Runner',
        net: 3974,
        total: 4738,
        unique_editors: 4,
        edits: 36,
        urls: 'https://en.wikipedia.org/wiki/Homestar_Runner',
      },
    ],
    net_asc: [
      {
        title: 'User talk:DragonflySixtyseven',
        net: -328276,
        total: 328276,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User_talk:DragonflySixtyseven',
      },
      {
        title: "Wikipedia:Administrators' noticeboard/Incidents",
        net: -308522,
        total: 308522,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Administrators%27_noticeboard/Incidents',
      },
      {
        title: 'Violet (color)',
        net: -142507,
        total: 142507,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Violet_(color)',
      },
      {
        title: 'Oakland, California',
        net: -99822,
        total: 102972,
        unique_editors: 5,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Oakland,_California',
      },
      {
        title: 'Ireland',
        net: -91189,
        total: 91189,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Ireland',
      },
      {
        title: 'J. Robert Oppenheimer',
        net: -84848,
        total: 84884,
        unique_editors: 3,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/J._Robert_Oppenheimer',
      },
      {
        title: 'NBC',
        net: -65233,
        total: 65233,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/NBC',
      },
      {
        title: 'Scooby-Doo',
        net: -55876,
        total: 55876,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Scooby-Doo',
      },
      {
        title: 'Yu-Gi-Oh! Trading Card Game',
        net: -52925,
        total: 266691,
        unique_editors: 3,
        edits: 12,
        urls: 'https://en.wikipedia.org/wiki/Yu-Gi-Oh!_Trading_Card_Game',
      },
      {
        title: 'Boshin War',
        net: -49394,
        total: 49394,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Boshin_War',
      },
      {
        title: 'User talk:Sciurinæ',
        net: -48235,
        total: 48235,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Sciurin%C3%A6',
      },
      {
        title: 'Soviet women in World War II',
        net: -47790,
        total: 47790,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Soviet_women_in_World_War_II',
      },
      {
        title: 'Hookah',
        net: -40816,
        total: 40816,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Hookah',
      },
      {
        title: 'Heavy metal music',
        net: -40271,
        total: 40553,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Heavy_metal_music',
      },
      {
        title: 'Margaret Sanger',
        net: -33204,
        total: 33204,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Margaret_Sanger',
      },
    ],
  },
  UCSD: {
    net: [
      {
        title: 'User:AntiVandalBot',
        net: 720264,
        total: 720264,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/User:AntiVandalBot',
      },
      {
        title: 'Biological classification',
        net: 658153,
        total: 707129,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Taxonomy_(biology)',
      },
      {
        title: 'Short-beaked echidna',
        net: 537410,
        total: 537410,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Short-beaked_echidna',
      },
      {
        title: 'Ferydoon Zandi',
        net: 123347,
        total: 123347,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Ferydoon_Zandi',
      },
      {
        title: 'Help:Menu',
        net: 117608,
        total: 117608,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Help:Menu',
      },
      {
        title: 'Wikipedia:Article size',
        net: 116922,
        total: 116922,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Article_size',
      },
      {
        title: 'Hocking College',
        net: 97102,
        total: 97102,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Hocking_College',
      },
      {
        title: 'Portal:Current events/September 2005',
        net: 90184,
        total: 90184,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Portal:Current_events/September_2005',
      },
      {
        title: 'Talk:Imjin War',
        net: 86523,
        total: 86523,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Talk:Imjin_War',
      },
      {
        title: 'Arnold Schwarzenegger',
        net: 54547,
        total: 54547,
        unique_editors: 2,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/Arnold_Schwarzenegger',
      },
      {
        title: 'User talk:Gilliam',
        net: 44191,
        total: 44191,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User_talk:Gilliam',
      },
      {
        title: 'Furvert',
        net: 37866,
        total: 37866,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Furry_fandom',
      },
      {
        title: 'Krav Maga',
        net: 37703,
        total: 38805,
        unique_editors: 2,
        edits: 53,
        urls: 'https://en.wikipedia.org/wiki/Krav_Maga',
      },
      {
        title: 'Black August (film)',
        net: 37572,
        total: 37572,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Black_August_(film)',
      },
      {
        title: 'Martin Luther King Jr.',
        net: 35915,
        total: 35915,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Martin_Luther_King_Jr.',
      },
    ],
    total: [
      {
        title: 'User:AntiVandalBot',
        net: 720264,
        total: 720264,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/User:AntiVandalBot',
      },
      {
        title: 'Biological classification',
        net: 658153,
        total: 707129,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Taxonomy_(biology)',
      },
      {
        title: 'Short-beaked echidna',
        net: 537410,
        total: 537410,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Short-beaked_echidna',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33040,
        total: 198422,
        unique_editors: 28,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Talk:Hippie',
        net: -186462,
        total: 186462,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Talk:Hippie',
      },
      {
        title: 'Benjamin Franklin',
        net: -145250,
        total: 145336,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Benjamin_Franklin',
      },
      {
        title: 'Shia–Sunni relations',
        net: -126614,
        total: 126614,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Shia%E2%80%93Sunni_relations',
      },
      {
        title: 'Ferydoon Zandi',
        net: 123347,
        total: 123347,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Ferydoon_Zandi',
      },
      {
        title: 'Help:Menu',
        net: 117608,
        total: 117608,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Help:Menu',
      },
      {
        title: 'Wikipedia:Article size',
        net: 116922,
        total: 116922,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Article_size',
      },
      {
        title: 'Oakland, California',
        net: -114493,
        total: 114493,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Oakland,_California',
      },
      {
        title: 'Hocking College',
        net: 97102,
        total: 97102,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Hocking_College',
      },
      {
        title: 'Wikipedia',
        net: -93184,
        total: 93856,
        unique_editors: 6,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia',
      },
      {
        title: 'Portal:Current events/September 2005',
        net: 90184,
        total: 90184,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Portal:Current_events/September_2005',
      },
      {
        title: 'Talk:Imjin War',
        net: 86523,
        total: 86523,
        unique_editors: 1,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Talk:Imjin_War',
      },
    ],
    unique: [
      {
        title: 'University of California, San Diego',
        net: 18066,
        total: 34350,
        unique_editors: 151,
        edits: 244,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_San_Diego',
      },
      {
        title: 'Sun God Festival',
        net: 4443,
        total: 6407,
        unique_editors: 62,
        edits: 106,
        urls: 'https://en.wikipedia.org/wiki/Sun_God_Festival',
      },
      {
        title: 'Earl Warren College',
        net: 776,
        total: 10302,
        unique_editors: 41,
        edits: 85,
        urls: 'https://en.wikipedia.org/wiki/Earl_Warren_College',
      },
      {
        title: 'List of University of California, San Diego people',
        net: -8727,
        total: 18593,
        unique_editors: 36,
        edits: 67,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_San_Diego_people',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33040,
        total: 198422,
        unique_editors: 28,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 28811,
        total: 43171,
        unique_editors: 26,
        edits: 68,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Alaska Airlines',
        net: 2031,
        total: 4887,
        unique_editors: 26,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Alaska_Airlines',
      },
      {
        title: 'United Airlines fleet',
        net: 1339,
        total: 1593,
        unique_editors: 25,
        edits: 35,
        urls: 'https://en.wikipedia.org/wiki/United_Airlines_fleet',
      },
      {
        title: 'Sixth College',
        net: 11031,
        total: 15479,
        unique_editors: 25,
        edits: 62,
        urls: 'https://en.wikipedia.org/wiki/Sixth_College',
      },
      {
        title: 'Preuss School',
        net: -19591,
        total: 28243,
        unique_editors: 25,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Preuss_School',
      },
      {
        title: 'Wikipedia:Reference desk/Science',
        net: 13668,
        total: 13668,
        unique_editors: 23,
        edits: 36,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Science',
      },
      {
        title: 'Charles Zuker',
        net: 587,
        total: 3597,
        unique_editors: 23,
        edits: 39,
        urls: 'https://en.wikipedia.org/wiki/Charles_Zuker',
      },
      {
        title: 'Wikipedia:Reference desk/Miscellaneous',
        net: 9397,
        total: 9615,
        unique_editors: 21,
        edits: 28,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Miscellaneous',
      },
      {
        title: 'Joseph Wang',
        net: 1850,
        total: 5120,
        unique_editors: 20,
        edits: 128,
        urls: 'https://en.wikipedia.org/wiki/Joseph_Wang',
      },
      {
        title: 'Eleanor Roosevelt College',
        net: 1067,
        total: 1247,
        unique_editors: 19,
        edits: 22,
        urls: 'https://en.wikipedia.org/wiki/Eleanor_Roosevelt_College',
      },
    ],
    edits: [
      {
        title: 'University of California, San Diego',
        net: 18066,
        total: 34350,
        unique_editors: 151,
        edits: 244,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_San_Diego',
      },
      {
        title: 'Joseph Wang',
        net: 1850,
        total: 5120,
        unique_editors: 20,
        edits: 128,
        urls: 'https://en.wikipedia.org/wiki/Joseph_Wang',
      },
      {
        title: 'Sun God Festival',
        net: 4443,
        total: 6407,
        unique_editors: 62,
        edits: 106,
        urls: 'https://en.wikipedia.org/wiki/Sun_God_Festival',
      },
      {
        title: 'Carlsbad, California',
        net: 3425,
        total: 12521,
        unique_editors: 2,
        edits: 94,
        urls: 'https://en.wikipedia.org/wiki/Carlsbad,_California',
      },
      {
        title: 'Earl Warren College',
        net: 776,
        total: 10302,
        unique_editors: 41,
        edits: 85,
        urls: 'https://en.wikipedia.org/wiki/Earl_Warren_College',
      },
      {
        title: 'CyberPatriot',
        net: 33573,
        total: 34449,
        unique_editors: 19,
        edits: 84,
        urls: 'https://en.wikipedia.org/wiki/CyberPatriot',
      },
      {
        title: 'Alaska Airlines',
        net: 2031,
        total: 4887,
        unique_editors: 26,
        edits: 80,
        urls: 'https://en.wikipedia.org/wiki/Alaska_Airlines',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 28811,
        total: 43171,
        unique_editors: 26,
        edits: 68,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'List of University of California, San Diego people',
        net: -8727,
        total: 18593,
        unique_editors: 36,
        edits: 67,
        urls: 'https://en.wikipedia.org/wiki/List_of_University_of_California,_San_Diego_people',
      },
      {
        title: 'Sixth College',
        net: 11031,
        total: 15479,
        unique_editors: 25,
        edits: 62,
        urls: 'https://en.wikipedia.org/wiki/Sixth_College',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 33040,
        total: 198422,
        unique_editors: 28,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Preuss School',
        net: -19591,
        total: 28243,
        unique_editors: 25,
        edits: 56,
        urls: 'https://en.wikipedia.org/wiki/Preuss_School',
      },
      {
        title: 'California High-Speed Rail',
        net: 15095,
        total: 16165,
        unique_editors: 4,
        edits: 55,
        urls: 'https://en.wikipedia.org/wiki/California_High-Speed_Rail',
      },
      {
        title: 'Krav Maga',
        net: 37703,
        total: 38805,
        unique_editors: 2,
        edits: 53,
        urls: 'https://en.wikipedia.org/wiki/Krav_Maga',
      },
      {
        title: 'Diels–Alder reaction',
        net: 7449,
        total: 7587,
        unique_editors: 2,
        edits: 52,
        urls: 'https://en.wikipedia.org/wiki/Diels%E2%80%93Alder_reaction',
      },
    ],
    net_asc: [
      {
        title: 'Talk:Hippie',
        net: -186462,
        total: 186462,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Talk:Hippie',
      },
      {
        title: 'Benjamin Franklin',
        net: -145250,
        total: 145336,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Benjamin_Franklin',
      },
      {
        title: 'Shia–Sunni relations',
        net: -126614,
        total: 126614,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Shia%E2%80%93Sunni_relations',
      },
      {
        title: 'Oakland, California',
        net: -114493,
        total: 114493,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Oakland,_California',
      },
      {
        title: 'Wikipedia',
        net: -93184,
        total: 93856,
        unique_editors: 6,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia',
      },
      {
        title: 'Greco-Persian Wars',
        net: -81857,
        total: 81857,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Greco-Persian_Wars',
      },
      {
        title: 'Conservatism',
        net: -74309,
        total: 74309,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Conservatism',
      },
      {
        title: 'Hacker',
        net: -71459,
        total: 71521,
        unique_editors: 1,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Hacker',
      },
      {
        title: 'Cheetah',
        net: -69791,
        total: 70097,
        unique_editors: 2,
        edits: 4,
        urls: 'https://en.wikipedia.org/wiki/Cheetah',
      },
      {
        title: 'Rush (band)',
        net: -63570,
        total: 63570,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Rush_(band)',
      },
      {
        title: 'San Antonio Spurs',
        net: -54036,
        total: 54114,
        unique_editors: 2,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/San_Antonio_Spurs',
      },
      {
        title: 'Banu Qurayza',
        net: -51610,
        total: 51610,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Banu_Qurayza',
      },
      {
        title: 'Republic',
        net: -51322,
        total: 51322,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Republic',
      },
      {
        title: 'Lobster',
        net: -50516,
        total: 50664,
        unique_editors: 4,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Lobster',
      },
      {
        title: 'Magic: The Gathering',
        net: -50093,
        total: 50383,
        unique_editors: 5,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Magic:_The_Gathering',
      },
    ],
  },
  UCSF: {
    net: [
      {
        title: 'Transgender Day of Remembrance',
        net: 50459,
        total: 50459,
        unique_editors: 1,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Transgender_Day_of_Remembrance',
      },
      {
        title: 'Nordic race',
        net: 45165,
        total: 63627,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Nordic_race',
      },
      {
        title: 'User:KristinaHanspers/Test2',
        net: 22732,
        total: 22732,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:KristinaHanspers/Test2',
      },
      {
        title: 'List of The Boat Race results',
        net: 21255,
        total: 32443,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/List_of_The_Boat_Race_results',
      },
      {
        title: 'Musket',
        net: 20111,
        total: 20111,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Musket',
      },
      {
        title: 'Wikipedia:Reference desk/Science',
        net: 18865,
        total: 18953,
        unique_editors: 2,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Science',
      },
      {
        title: 'User:3shalim26/sandbox',
        net: 18364,
        total: 18364,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:3shalim26/sandbox',
      },
      {
        title: 'User:VTONGUCSF/sandbox',
        net: 16763,
        total: 16763,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:VTONGUCSF/sandbox',
      },
      {
        title: 'Talk:Encyclopedia',
        net: 12748,
        total: 12748,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Encyclopedia',
      },
      {
        title: 'Talk:Nuclear weapon',
        net: 12419,
        total: 12419,
        unique_editors: 2,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:Nuclear_weapon',
      },
      {
        title: 'Talk:Ethology',
        net: 10708,
        total: 10708,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Ethology',
      },
      {
        title: 'Steven A. Schroeder',
        net: 10698,
        total: 11960,
        unique_editors: 6,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Steven_A._Schroeder',
      },
      {
        title: 'Management of depression',
        net: 10219,
        total: 10219,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Management_of_depression',
      },
      {
        title: 'Talk:University of California, Berkeley',
        net: 10032,
        total: 10406,
        unique_editors: 1,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Berkeley',
      },
      {
        title: 'Inflammation',
        net: 9443,
        total: 9443,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Inflammation',
      },
    ],
    total: [
      {
        title: 'Lung cancer',
        net: -76837,
        total: 76837,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Lung_cancer',
      },
      {
        title: 'Nordic race',
        net: 45165,
        total: 63627,
        unique_editors: 2,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Nordic_race',
      },
      {
        title: 'Transgender Day of Remembrance',
        net: 50459,
        total: 50459,
        unique_editors: 1,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Transgender_Day_of_Remembrance',
      },
      {
        title: 'La Excelencia',
        net: -45580,
        total: 46120,
        unique_editors: 2,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/La_Excelencia',
      },
      {
        title: 'List of The Boat Race results',
        net: 21255,
        total: 32443,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/List_of_The_Boat_Race_results',
      },
      {
        title: 'User:AlexanderPico/Test1',
        net: 8388,
        total: 25226,
        unique_editors: 1,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/User:AlexanderPico/Test1',
      },
      {
        title: 'User:KristinaHanspers/Test2',
        net: 22732,
        total: 22732,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:KristinaHanspers/Test2',
      },
      {
        title: 'List of Battlestar Galactica (2004 TV series) episodes',
        net: -21038,
        total: 21038,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Battlestar_Galactica_(2004_TV_series)_episodes',
      },
      {
        title: 'Musket',
        net: 20111,
        total: 20111,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Musket',
      },
      {
        title: 'Banishment Act 1697',
        net: -19452,
        total: 19452,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Banishment_Act_1697',
      },
      {
        title: 'Wikipedia:Reference desk/Science',
        net: 18865,
        total: 18953,
        unique_editors: 2,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Science',
      },
      {
        title: 'User:3shalim26/sandbox',
        net: 18364,
        total: 18364,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/User:3shalim26/sandbox',
      },
      {
        title: 'User:VTONGUCSF/sandbox',
        net: 16763,
        total: 16763,
        unique_editors: 1,
        edits: 3,
        urls: 'https://en.wikipedia.org/wiki/User:VTONGUCSF/sandbox',
      },
      {
        title: 'Talk:Encyclopedia',
        net: 12748,
        total: 12748,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Talk:Encyclopedia',
      },
      {
        title: 'Talk:Nuclear weapon',
        net: 12419,
        total: 12419,
        unique_editors: 2,
        edits: 9,
        urls: 'https://en.wikipedia.org/wiki/Talk:Nuclear_weapon',
      },
    ],
    unique: [
      {
        title: 'University of California, San Francisco',
        net: 7736,
        total: 9732,
        unique_editors: 35,
        edits: 65,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_San_Francisco',
      },
      {
        title: 'Matrilineality in Judaism',
        net: 7590,
        total: 11084,
        unique_editors: 7,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Matrilineality_in_Judaism',
      },
      {
        title: 'Victor Wong (actor, born 1927)',
        net: 1473,
        total: 1475,
        unique_editors: 6,
        edits: 16,
        urls: 'https://en.wikipedia.org/wiki/Victor_Wong_(actor,_born_1927)',
      },
      {
        title: 'Steven A. Schroeder',
        net: 10698,
        total: 11960,
        unique_editors: 6,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Steven_A._Schroeder',
      },
      {
        title: 'Monica Gandhi',
        net: -8031,
        total: 8373,
        unique_editors: 6,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Monica_Gandhi',
      },
      {
        title: 'Mission Bay, San Francisco',
        net: 2850,
        total: 2890,
        unique_editors: 6,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Mission_Bay,_San_Francisco',
      },
      {
        title: 'Wikipedia:Sandbox/Archive',
        net: 286,
        total: 286,
        unique_editors: 5,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox/Archive',
      },
      {
        title: 'Wikipedia:Sandbox',
        net: 618,
        total: 4866,
        unique_editors: 5,
        edits: 16,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Sandbox',
      },
      {
        title: 'Wendy Berry Mendes',
        net: 552,
        total: 586,
        unique_editors: 5,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Wendy_Berry_Mendes',
      },
      {
        title: 'University of California, Riverside',
        net: 431,
        total: 2495,
        unique_editors: 5,
        edits: 16,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_Riverside',
      },
      {
        title: 'UBiome',
        net: 825,
        total: 1687,
        unique_editors: 5,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/UBiome',
      },
      {
        title: 'Peter Walter',
        net: 207,
        total: 299,
        unique_editors: 5,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Peter_Walter',
      },
      {
        title: 'Jack Turban',
        net: 1442,
        total: 7698,
        unique_editors: 5,
        edits: 7,
        urls: 'https://en.wikipedia.org/wiki/Jack_Turban',
      },
      {
        title: 'Clubes de Ciencia',
        net: 791,
        total: 817,
        unique_editors: 5,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/Clubes_de_Ciencia',
      },
      {
        title: 'Caddyshack',
        net: 2838,
        total: 2838,
        unique_editors: 5,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/Caddyshack',
      },
    ],
    edits: [
      {
        title: 'Matrilineality in Judaism',
        net: 7590,
        total: 11084,
        unique_editors: 7,
        edits: 74,
        urls: 'https://en.wikipedia.org/wiki/Matrilineality_in_Judaism',
      },
      {
        title: 'University of California, San Francisco',
        net: 7736,
        total: 9732,
        unique_editors: 35,
        edits: 65,
        urls: 'https://en.wikipedia.org/wiki/University_of_California,_San_Francisco',
      },
      {
        title: 'Wikipedia:Reference desk/Science',
        net: 18865,
        total: 18953,
        unique_editors: 2,
        edits: 51,
        urls: 'https://en.wikipedia.org/wiki/Wikipedia:Reference_desk/Science',
      },
      {
        title: 'Jo Stone-Fewings',
        net: 779,
        total: 1631,
        unique_editors: 4,
        edits: 34,
        urls: 'https://en.wikipedia.org/wiki/Jo_Stone-Fewings',
      },
      {
        title: 'Jonathan Weissman',
        net: 819,
        total: 1943,
        unique_editors: 1,
        edits: 33,
        urls: 'https://en.wikipedia.org/wiki/Jonathan_Weissman',
      },
      {
        title: 'Steven A. Schroeder',
        net: 10698,
        total: 11960,
        unique_editors: 6,
        edits: 31,
        urls: 'https://en.wikipedia.org/wiki/Steven_A._Schroeder',
      },
      {
        title: 'Mission Bay, San Francisco',
        net: 2850,
        total: 2890,
        unique_editors: 6,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Mission_Bay,_San_Francisco',
      },
      {
        title: 'Bush v. Gore',
        net: 878,
        total: 6326,
        unique_editors: 1,
        edits: 26,
        urls: 'https://en.wikipedia.org/wiki/Bush_v._Gore',
      },
      {
        title: 'Newspaper endorsements in the 2008 United States presidential primaries',
        net: 1346,
        total: 2080,
        unique_editors: 1,
        edits: 23,
        urls: 'https://en.wikipedia.org/wiki/Newspaper_endorsements_in_the_2008_United_States_presidential_primaries',
      },
      {
        title: 'Water resources management in Argentina',
        net: 2243,
        total: 3645,
        unique_editors: 3,
        edits: 21,
        urls: 'https://en.wikipedia.org/wiki/Water_resources_management_in_Argentina',
      },
      {
        title: 'DuPont (1802–2017)',
        net: 4116,
        total: 6490,
        unique_editors: 1,
        edits: 21,
        urls: 'https://en.wikipedia.org/wiki/DuPont',
      },
      {
        title: 'Vinay Prasad',
        net: 1543,
        total: 2325,
        unique_editors: 1,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Vinay_Prasad',
      },
      {
        title: 'Talk:University of California, Berkeley',
        net: 10032,
        total: 10406,
        unique_editors: 1,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Talk:University_of_California,_Berkeley',
      },
      {
        title: 'Emergency psychiatry',
        net: 2940,
        total: 3038,
        unique_editors: 1,
        edits: 20,
        urls: 'https://en.wikipedia.org/wiki/Emergency_psychiatry',
      },
      {
        title: 'Caddyshack',
        net: 2838,
        total: 2838,
        unique_editors: 5,
        edits: 19,
        urls: 'https://en.wikipedia.org/wiki/Caddyshack',
      },
    ],
    net_asc: [
      {
        title: 'Lung cancer',
        net: -76837,
        total: 76837,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Lung_cancer',
      },
      {
        title: 'La Excelencia',
        net: -45580,
        total: 46120,
        unique_editors: 2,
        edits: 17,
        urls: 'https://en.wikipedia.org/wiki/La_Excelencia',
      },
      {
        title: 'List of Battlestar Galactica (2004 TV series) episodes',
        net: -21038,
        total: 21038,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/List_of_Battlestar_Galactica_(2004_TV_series)_episodes',
      },
      {
        title: 'Banishment Act 1697',
        net: -19452,
        total: 19452,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Banishment_Act_1697',
      },
      {
        title: 'Antidepressant',
        net: -11484,
        total: 11484,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Antidepressant',
      },
      {
        title: 'Fluoxetine',
        net: -11226,
        total: 11226,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Fluoxetine',
      },
      {
        title: 'Ethology',
        net: -10307,
        total: 10307,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Ethology',
      },
      {
        title: 'Dan Littman',
        net: -9110,
        total: 9472,
        unique_editors: 4,
        edits: 5,
        urls: 'https://en.wikipedia.org/wiki/Dan_Littman',
      },
      {
        title: 'List of timelines of World War II',
        net: -8897,
        total: 9017,
        unique_editors: 1,
        edits: 8,
        urls: 'https://en.wikipedia.org/wiki/List_of_timelines_of_World_War_II',
      },
      {
        title: 'Monica Gandhi',
        net: -8031,
        total: 8373,
        unique_editors: 6,
        edits: 11,
        urls: 'https://en.wikipedia.org/wiki/Monica_Gandhi',
      },
      {
        title: 'Google Toolbar',
        net: -7271,
        total: 7533,
        unique_editors: 1,
        edits: 6,
        urls: 'https://en.wikipedia.org/wiki/Google_Toolbar',
      },
      {
        title: 'Perfect Strangers (TV series)',
        net: -5243,
        total: 5243,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Perfect_Strangers_(TV_series)',
      },
      {
        title: 'Science studies',
        net: -4997,
        total: 4997,
        unique_editors: 1,
        edits: 1,
        urls: 'https://en.wikipedia.org/wiki/Science_studies',
      },
      {
        title: 'Rocky Mountain Laboratories',
        net: -4456,
        total: 4474,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Rocky_Mountain_Laboratories',
      },
      {
        title: 'Fibonacci',
        net: -4002,
        total: 4002,
        unique_editors: 1,
        edits: 2,
        urls: 'https://en.wikipedia.org/wiki/Fibonacci',
      },
    ],
  },
};

const timeData = [
  {
    year: 2001,
    UCLA: {
      edit_count: -40592,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCB: {
      edit_count: -376006,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCSC: {
      edit_count: 26,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCSD: {
      edit_count: 30,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCR: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCI: {
      edit_count: -92958,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCD: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCSB: {
      edit_count: 605,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCSF: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCOP: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCM: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
  },
  {
    year: 2002,
    UCLA: {
      edit_count: -40730,
      edit_volume: 5,
      edit_volume_strict: -40592,
    },
    UCB: {
      edit_count: -292575,
      edit_volume: 80,
      edit_volume_strict: -376006,
    },
    UCSC: {
      edit_count: 14993,
      edit_volume: 1,
      edit_volume_strict: 26,
    },
    UCSD: {
      edit_count: 7264,
      edit_volume: 1,
      edit_volume_strict: 30,
    },
    UCR: {
      edit_count: 41240,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCI: {
      edit_count: -91476,
      edit_volume: 10,
      edit_volume_strict: -92958,
    },
    UCD: {
      edit_count: 1849,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCSB: {
      edit_count: 5771,
      edit_volume: 2,
      edit_volume_strict: 605,
    },
    UCSF: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCOP: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCM: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
  },
  {
    year: 2003,
    UCLA: {
      edit_count: -16656,
      edit_volume: 12,
      edit_volume_strict: -40730,
    },
    UCB: {
      edit_count: -230771,
      edit_volume: 385,
      edit_volume_strict: -292575,
    },
    UCSC: {
      edit_count: 16983,
      edit_volume: 119,
      edit_volume_strict: 14993,
    },
    UCSD: {
      edit_count: 12604,
      edit_volume: 171,
      edit_volume_strict: 7264,
    },
    UCR: {
      edit_count: 45596,
      edit_volume: 109,
      edit_volume_strict: 41240,
    },
    UCI: {
      edit_count: -64868,
      edit_volume: 17,
      edit_volume_strict: -91476,
    },
    UCD: {
      edit_count: 15345,
      edit_volume: 9,
      edit_volume_strict: 1849,
    },
    UCSB: {
      edit_count: 40577,
      edit_volume: 23,
      edit_volume_strict: 5771,
    },
    UCSF: {
      edit_count: 2673,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCOP: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCM: {
      edit_count: 0,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
  },
  {
    year: 2004,
    UCLA: {
      edit_count: 18053,
      edit_volume: 102,
      edit_volume_strict: -16656,
    },
    UCB: {
      edit_count: -254360,
      edit_volume: 729,
      edit_volume_strict: -230771,
    },
    UCSC: {
      edit_count: 118698,
      edit_volume: 147,
      edit_volume_strict: 16983,
    },
    UCSD: {
      edit_count: 58572,
      edit_volume: 189,
      edit_volume_strict: 12604,
    },
    UCR: {
      edit_count: -48813,
      edit_volume: 139,
      edit_volume_strict: 45596,
    },
    UCI: {
      edit_count: -42306,
      edit_volume: 226,
      edit_volume_strict: -64868,
    },
    UCD: {
      edit_count: 51541,
      edit_volume: 68,
      edit_volume_strict: 15345,
    },
    UCSB: {
      edit_count: 66988,
      edit_volume: 129,
      edit_volume_strict: 40577,
    },
    UCSF: {
      edit_count: 17295,
      edit_volume: 8,
      edit_volume_strict: 2673,
    },
    UCOP: {
      edit_count: 607,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
    UCM: {
      edit_count: 2235,
      edit_volume: 0,
      edit_volume_strict: 0,
    },
  },
  {
    year: 2005,
    UCLA: {
      edit_count: -100303,
      edit_volume: 570,
      edit_volume_strict: 18053,
    },
    UCB: {
      edit_count: -518258,
      edit_volume: 1400,
      edit_volume_strict: -254360,
    },
    UCSC: {
      edit_count: 144632,
      edit_volume: 391,
      edit_volume_strict: 118698,
    },
    UCSD: {
      edit_count: 644497,
      edit_volume: 541,
      edit_volume_strict: 58572,
    },
    UCR: {
      edit_count: -62058,
      edit_volume: 339,
      edit_volume_strict: -48813,
    },
    UCI: {
      edit_count: -18215,
      edit_volume: 495,
      edit_volume_strict: -42306,
    },
    UCD: {
      edit_count: 17637,
      edit_volume: 574,
      edit_volume_strict: 51541,
    },
    UCSB: {
      edit_count: 83054,
      edit_volume: 573,
      edit_volume_strict: 66988,
    },
    UCSF: {
      edit_count: 67007,
      edit_volume: 181,
      edit_volume_strict: 17295,
    },
    UCOP: {
      edit_count: 2622,
      edit_volume: 21,
      edit_volume_strict: 607,
    },
    UCM: {
      edit_count: 9227,
      edit_volume: 2,
      edit_volume_strict: 2235,
    },
  },
  {
    year: 2006,
    UCLA: {
      edit_count: 420150,
      edit_volume: 2908,
      edit_volume_strict: -100303,
    },
    UCB: {
      edit_count: -686133,
      edit_volume: 4673,
      edit_volume_strict: -518258,
    },
    UCSC: {
      edit_count: -158395,
      edit_volume: 1395,
      edit_volume_strict: 144632,
    },
    UCSD: {
      edit_count: 1844871,
      edit_volume: 2534,
      edit_volume_strict: 644497,
    },
    UCR: {
      edit_count: -63008,
      edit_volume: 1008,
      edit_volume_strict: -62058,
    },
    UCI: {
      edit_count: -1175141,
      edit_volume: 2002,
      edit_volume_strict: -18215,
    },
    UCD: {
      edit_count: 87935,
      edit_volume: 1685,
      edit_volume_strict: 17637,
    },
    UCSB: {
      edit_count: 1046928,
      edit_volume: 1817,
      edit_volume_strict: 83054,
    },
    UCSF: {
      edit_count: 146259,
      edit_volume: 672,
      edit_volume_strict: 67007,
    },
    UCOP: {
      edit_count: 7257,
      edit_volume: 40,
      edit_volume_strict: 2622,
    },
    UCM: {
      edit_count: 2435,
      edit_volume: 75,
      edit_volume_strict: 9227,
    },
  },
  {
    year: 2007,
    UCLA: {
      edit_count: 4738965,
      edit_volume: 8275,
      edit_volume_strict: 419255,
    },
    UCB: {
      edit_count: -544952,
      edit_volume: 10021,
      edit_volume_strict: -686133,
    },
    UCSC: {
      edit_count: -408754,
      edit_volume: 3883,
      edit_volume_strict: -158395,
    },
    UCSD: {
      edit_count: 1558490,
      edit_volume: 6900,
      edit_volume_strict: 1844871,
    },
    UCR: {
      edit_count: -227889,
      edit_volume: 2424,
      edit_volume_strict: -63008,
    },
    UCI: {
      edit_count: -1074219,
      edit_volume: 5170,
      edit_volume_strict: -1175141,
    },
    UCD: {
      edit_count: -1335958,
      edit_volume: 4839,
      edit_volume_strict: 87935,
    },
    UCSB: {
      edit_count: 1146824,
      edit_volume: 5280,
      edit_volume_strict: 1046928,
    },
    UCSF: {
      edit_count: 248973,
      edit_volume: 1431,
      edit_volume_strict: 146259,
    },
    UCOP: {
      edit_count: 9778,
      edit_volume: 102,
      edit_volume_strict: 7257,
    },
    UCM: {
      edit_count: -61519,
      edit_volume: 265,
      edit_volume_strict: 2435,
    },
  },
  {
    year: 2008,
    UCLA: {
      edit_count: 6273152,
      edit_volume: 15617,
      edit_volume_strict: 4738070,
    },
    UCB: {
      edit_count: -607734,
      edit_volume: 15060,
      edit_volume_strict: -544952,
    },
    UCSC: {
      edit_count: -991449,
      edit_volume: 6235,
      edit_volume_strict: -408754,
    },
    UCSD: {
      edit_count: 1247125,
      edit_volume: 11169,
      edit_volume_strict: 1558490,
    },
    UCR: {
      edit_count: -347815,
      edit_volume: 4677,
      edit_volume_strict: -227889,
    },
    UCI: {
      edit_count: -1159824,
      edit_volume: 8165,
      edit_volume_strict: -1074219,
    },
    UCD: {
      edit_count: -1172552,
      edit_volume: 7504,
      edit_volume_strict: -1335958,
    },
    UCSB: {
      edit_count: 1054638,
      edit_volume: 8715,
      edit_volume_strict: 1146824,
    },
    UCSF: {
      edit_count: 254416,
      edit_volume: 2408,
      edit_volume_strict: 248973,
    },
    UCOP: {
      edit_count: 11412,
      edit_volume: 135,
      edit_volume_strict: 9778,
    },
    UCM: {
      edit_count: -64696,
      edit_volume: 492,
      edit_volume_strict: -61519,
    },
  },
  {
    year: 2009,
    UCLA: {
      edit_count: 6274685,
      edit_volume: 20725,
      edit_volume_strict: 6272257,
    },
    UCB: {
      edit_count: -471360,
      edit_volume: 19497,
      edit_volume_strict: -607734,
    },
    UCSC: {
      edit_count: -1173743,
      edit_volume: 8488,
      edit_volume_strict: -991449,
    },
    UCSD: {
      edit_count: 1052847,
      edit_volume: 14188,
      edit_volume_strict: 1247125,
    },
    UCR: {
      edit_count: -323907,
      edit_volume: 6341,
      edit_volume_strict: -347815,
    },
    UCI: {
      edit_count: -1269648,
      edit_volume: 10524,
      edit_volume_strict: -1159824,
    },
    UCD: {
      edit_count: -1099816,
      edit_volume: 9865,
      edit_volume_strict: -1172552,
    },
    UCSB: {
      edit_count: 1025798,
      edit_volume: 11049,
      edit_volume_strict: 1054638,
    },
    UCSF: {
      edit_count: 314637,
      edit_volume: 3153,
      edit_volume_strict: 254416,
    },
    UCOP: {
      edit_count: 10056,
      edit_volume: 150,
      edit_volume_strict: 11412,
    },
    UCM: {
      edit_count: -16629,
      edit_volume: 737,
      edit_volume_strict: -64696,
    },
  },
  {
    year: 2010,
    UCLA: {
      edit_count: 6405302,
      edit_volume: 24188,
      edit_volume_strict: 6273790,
    },
    UCB: {
      edit_count: -247213,
      edit_volume: 23138,
      edit_volume_strict: -471360,
    },
    UCSC: {
      edit_count: -1116660,
      edit_volume: 11072,
      edit_volume_strict: -1173743,
    },
    UCSD: {
      edit_count: 1002713,
      edit_volume: 16858,
      edit_volume_strict: 1052847,
    },
    UCR: {
      edit_count: -313473,
      edit_volume: 6864,
      edit_volume_strict: -323907,
    },
    UCI: {
      edit_count: -1101228,
      edit_volume: 13203,
      edit_volume_strict: -1269648,
    },
    UCD: {
      edit_count: -1116032,
      edit_volume: 11450,
      edit_volume_strict: -1099816,
    },
    UCSB: {
      edit_count: 991069,
      edit_volume: 12743,
      edit_volume_strict: 1025798,
    },
    UCSF: {
      edit_count: 406530,
      edit_volume: 3909,
      edit_volume_strict: 314637,
    },
    UCOP: {
      edit_count: 11030,
      edit_volume: 166,
      edit_volume_strict: 10056,
    },
    UCM: {
      edit_count: -16501,
      edit_volume: 942,
      edit_volume_strict: -16629,
    },
  },
  {
    year: 2011,
    UCLA: {
      edit_count: 6443559,
      edit_volume: 27442,
      edit_volume_strict: 6404407,
    },
    UCB: {
      edit_count: -82441,
      edit_volume: 26003,
      edit_volume_strict: -247213,
    },
    UCSC: {
      edit_count: -998170,
      edit_volume: 12783,
      edit_volume_strict: -1116660,
    },
    UCSD: {
      edit_count: 1091791,
      edit_volume: 19119,
      edit_volume_strict: 1002713,
    },
    UCR: {
      edit_count: -307682,
      edit_volume: 7296,
      edit_volume_strict: -313473,
    },
    UCI: {
      edit_count: -1079007,
      edit_volume: 15046,
      edit_volume_strict: -1101228,
    },
    UCD: {
      edit_count: -1113587,
      edit_volume: 12666,
      edit_volume_strict: -1116032,
    },
    UCSB: {
      edit_count: 1090736,
      edit_volume: 14515,
      edit_volume_strict: 991069,
    },
    UCSF: {
      edit_count: 506160,
      edit_volume: 4581,
      edit_volume_strict: 406530,
    },
    UCOP: {
      edit_count: 11903,
      edit_volume: 182,
      edit_volume_strict: 11030,
    },
    UCM: {
      edit_count: -12140,
      edit_volume: 1082,
      edit_volume_strict: -16501,
    },
  },
  {
    year: 2012,
    UCLA: {
      edit_count: 6511602,
      edit_volume: 29797,
      edit_volume_strict: 6442664,
    },
    UCB: {
      edit_count: 87181,
      edit_volume: 28422,
      edit_volume_strict: -82441,
    },
    UCSC: {
      edit_count: -909661,
      edit_volume: 14147,
      edit_volume_strict: -998170,
    },
    UCSD: {
      edit_count: 1167638,
      edit_volume: 20764,
      edit_volume_strict: 1091791,
    },
    UCR: {
      edit_count: -307014,
      edit_volume: 7555,
      edit_volume_strict: -307682,
    },
    UCI: {
      edit_count: -1048954,
      edit_volume: 16509,
      edit_volume_strict: -1079007,
    },
    UCD: {
      edit_count: -1035614,
      edit_volume: 13822,
      edit_volume_strict: -1113587,
    },
    UCSB: {
      edit_count: 1218838,
      edit_volume: 16029,
      edit_volume_strict: 1090736,
    },
    UCSF: {
      edit_count: 522024,
      edit_volume: 5129,
      edit_volume_strict: 506160,
    },
    UCOP: {
      edit_count: 11235,
      edit_volume: 293,
      edit_volume_strict: 11903,
    },
    UCM: {
      edit_count: -10614,
      edit_volume: 1192,
      edit_volume_strict: -12140,
    },
  },
  {
    year: 2013,
    UCLA: {
      edit_count: 6626333,
      edit_volume: 31952,
      edit_volume_strict: 6510707,
    },
    UCB: {
      edit_count: 140746,
      edit_volume: 30354,
      edit_volume_strict: 87181,
    },
    UCSC: {
      edit_count: -814524,
      edit_volume: 15150,
      edit_volume_strict: -909661,
    },
    UCSD: {
      edit_count: 1294578,
      edit_volume: 22265,
      edit_volume_strict: 1167638,
    },
    UCR: {
      edit_count: -300473,
      edit_volume: 7856,
      edit_volume_strict: -307014,
    },
    UCI: {
      edit_count: -1107333,
      edit_volume: 18104,
      edit_volume_strict: -1048954,
    },
    UCD: {
      edit_count: -982819,
      edit_volume: 14750,
      edit_volume_strict: -1035614,
    },
    UCSB: {
      edit_count: 1336652,
      edit_volume: 17380,
      edit_volume_strict: 1218838,
    },
    UCSF: {
      edit_count: 524644,
      edit_volume: 5339,
      edit_volume_strict: 522024,
    },
    UCOP: {
      edit_count: 12296,
      edit_volume: 322,
      edit_volume_strict: 11235,
    },
    UCM: {
      edit_count: -11140,
      edit_volume: 1289,
      edit_volume_strict: -10614,
    },
  },
  {
    year: 2014,
    UCLA: {
      edit_count: 6579904,
      edit_volume: 34031,
      edit_volume_strict: 6625438,
    },
    UCB: {
      edit_count: -44205,
      edit_volume: 32298,
      edit_volume_strict: 140746,
    },
    UCSC: {
      edit_count: -799173,
      edit_volume: 15889,
      edit_volume_strict: -814524,
    },
    UCSD: {
      edit_count: 1322469,
      edit_volume: 23526,
      edit_volume_strict: 1294578,
    },
    UCR: {
      edit_count: -292914,
      edit_volume: 8154,
      edit_volume_strict: -300473,
    },
    UCI: {
      edit_count: -1071909,
      edit_volume: 19134,
      edit_volume_strict: -1107333,
    },
    UCD: {
      edit_count: -726106,
      edit_volume: 15389,
      edit_volume_strict: -982819,
    },
    UCSB: {
      edit_count: 1708501,
      edit_volume: 19237,
      edit_volume_strict: 1336652,
    },
    UCSF: {
      edit_count: 537938,
      edit_volume: 5557,
      edit_volume_strict: 524644,
    },
    UCOP: {
      edit_count: 12713,
      edit_volume: 330,
      edit_volume_strict: 12296,
    },
    UCM: {
      edit_count: -8291,
      edit_volume: 1381,
      edit_volume_strict: -11140,
    },
  },
  {
    year: 2015,
    UCLA: {
      edit_count: 6795796,
      edit_volume: 36325,
      edit_volume_strict: 6579009,
    },
    UCB: {
      edit_count: -44138,
      edit_volume: 34537,
      edit_volume_strict: -44205,
    },
    UCSC: {
      edit_count: -801868,
      edit_volume: 16359,
      edit_volume_strict: -799173,
    },
    UCSD: {
      edit_count: 1390851,
      edit_volume: 24531,
      edit_volume_strict: 1322469,
    },
    UCR: {
      edit_count: -289619,
      edit_volume: 8341,
      edit_volume_strict: -292914,
    },
    UCI: {
      edit_count: -1027241,
      edit_volume: 19838,
      edit_volume_strict: -1071909,
    },
    UCD: {
      edit_count: -562338,
      edit_volume: 17112,
      edit_volume_strict: -726106,
    },
    UCSB: {
      edit_count: 2020257,
      edit_volume: 21042,
      edit_volume_strict: 1708501,
    },
    UCSF: {
      edit_count: 586100,
      edit_volume: 5746,
      edit_volume_strict: 537938,
    },
    UCOP: {
      edit_count: 13450,
      edit_volume: 357,
      edit_volume_strict: 12713,
    },
    UCM: {
      edit_count: -5543,
      edit_volume: 1503,
      edit_volume_strict: -8291,
    },
  },
  {
    year: 2016,
    UCLA: {
      edit_count: 6943821,
      edit_volume: 38332,
      edit_volume_strict: 6794901,
    },
    UCB: {
      edit_count: -5132,
      edit_volume: 35815,
      edit_volume_strict: -44138,
    },
    UCSC: {
      edit_count: -791263,
      edit_volume: 16828,
      edit_volume_strict: -801868,
    },
    UCSD: {
      edit_count: 1354219,
      edit_volume: 25441,
      edit_volume_strict: 1390851,
    },
    UCR: {
      edit_count: -283979,
      edit_volume: 8467,
      edit_volume_strict: -289619,
    },
    UCI: {
      edit_count: -965825,
      edit_volume: 20383,
      edit_volume_strict: -1027241,
    },
    UCD: {
      edit_count: -519413,
      edit_volume: 18796,
      edit_volume_strict: -562338,
    },
    UCSB: {
      edit_count: 2128430,
      edit_volume: 22882,
      edit_volume_strict: 2020257,
    },
    UCSF: {
      edit_count: 577928,
      edit_volume: 6092,
      edit_volume_strict: 586100,
    },
    UCOP: {
      edit_count: 17527,
      edit_volume: 385,
      edit_volume_strict: 13450,
    },
    UCM: {
      edit_count: -11852,
      edit_volume: 1561,
      edit_volume_strict: -5543,
    },
  },
  {
    year: 2017,
    UCLA: {
      edit_count: 7009820,
      edit_volume: 42406,
      edit_volume_strict: 6942926,
    },
    UCB: {
      edit_count: 24869,
      edit_volume: 36882,
      edit_volume_strict: -5132,
    },
    UCSC: {
      edit_count: -806356,
      edit_volume: 17288,
      edit_volume_strict: -791263,
    },
    UCSD: {
      edit_count: 1342328,
      edit_volume: 26319,
      edit_volume_strict: 1354219,
    },
    UCR: {
      edit_count: -259258,
      edit_volume: 8603,
      edit_volume_strict: -283979,
    },
    UCI: {
      edit_count: -874476,
      edit_volume: 20862,
      edit_volume_strict: -965825,
    },
    UCD: {
      edit_count: -263799,
      edit_volume: 19440,
      edit_volume_strict: -519413,
    },
    UCSB: {
      edit_count: 2228900,
      edit_volume: 23777,
      edit_volume_strict: 2128430,
    },
    UCSF: {
      edit_count: 588151,
      edit_volume: 6278,
      edit_volume_strict: 577928,
    },
    UCOP: {
      edit_count: 17824,
      edit_volume: 435,
      edit_volume_strict: 17527,
    },
    UCM: {
      edit_count: -8354,
      edit_volume: 1609,
      edit_volume_strict: -11852,
    },
  },
  {
    year: 2018,
    UCLA: {
      edit_count: 6726709,
      edit_volume: 44733,
      edit_volume_strict: 7008757,
    },
    UCB: {
      edit_count: 13514,
      edit_volume: 37823,
      edit_volume_strict: 24869,
    },
    UCSC: {
      edit_count: -784308,
      edit_volume: 17664,
      edit_volume_strict: -806356,
    },
    UCSD: {
      edit_count: 1431415,
      edit_volume: 26999,
      edit_volume_strict: 1342328,
    },
    UCR: {
      edit_count: -260422,
      edit_volume: 8737,
      edit_volume_strict: -259260,
    },
    UCI: {
      edit_count: -706425,
      edit_volume: 21493,
      edit_volume_strict: -874476,
    },
    UCD: {
      edit_count: 130734,
      edit_volume: 20243,
      edit_volume_strict: -263799,
    },
    UCSB: {
      edit_count: 2221940,
      edit_volume: 24292,
      edit_volume_strict: 2228900,
    },
    UCSF: {
      edit_count: 667392,
      edit_volume: 6563,
      edit_volume_strict: 588151,
    },
    UCOP: {
      edit_count: 18518,
      edit_volume: 444,
      edit_volume_strict: 17824,
    },
    UCM: {
      edit_count: -6705,
      edit_volume: 1656,
      edit_volume_strict: -8354,
    },
  },
  {
    year: 2019,
    UCLA: {
      edit_count: 6797062,
      edit_volume: 46071,
      edit_volume_strict: 6725646,
    },
    UCB: {
      edit_count: 37918,
      edit_volume: 38653,
      edit_volume_strict: 13516,
    },
    UCSC: {
      edit_count: -745417,
      edit_volume: 18297,
      edit_volume_strict: -784308,
    },
    UCSD: {
      edit_count: 1474127,
      edit_volume: 27898,
      edit_volume_strict: 1431415,
    },
    UCR: {
      edit_count: -256680,
      edit_volume: 8809,
      edit_volume_strict: -260424,
    },
    UCI: {
      edit_count: -578662,
      edit_volume: 22422,
      edit_volume_strict: -706425,
    },
    UCD: {
      edit_count: 440795,
      edit_volume: 20641,
      edit_volume_strict: 130734,
    },
    UCSB: {
      edit_count: 2265847,
      edit_volume: 24796,
      edit_volume_strict: 2221940,
    },
    UCSF: {
      edit_count: 685317,
      edit_volume: 6899,
      edit_volume_strict: 667392,
    },
    UCOP: {
      edit_count: 18483,
      edit_volume: 452,
      edit_volume_strict: 18518,
    },
    UCM: {
      edit_count: -6041,
      edit_volume: 1717,
      edit_volume_strict: -6705,
    },
  },
  {
    year: 2020,
    UCLA: {
      edit_count: 6820546,
      edit_volume: 47175,
      edit_volume_strict: 6795854,
    },
    UCB: {
      edit_count: 56584,
      edit_volume: 39385,
      edit_volume_strict: 37920,
    },
    UCSC: {
      edit_count: -731001,
      edit_volume: 19088,
      edit_volume_strict: -745463,
    },
    UCSD: {
      edit_count: 1478815,
      edit_volume: 28683,
      edit_volume_strict: 1474025,
    },
    UCR: {
      edit_count: -252065,
      edit_volume: 8875,
      edit_volume_strict: -256682,
    },
    UCI: {
      edit_count: -508654,
      edit_volume: 23179,
      edit_volume_strict: -578662,
    },
    UCD: {
      edit_count: 526063,
      edit_volume: 21012,
      edit_volume_strict: 440795,
    },
    UCSB: {
      edit_count: 2276141,
      edit_volume: 25209,
      edit_volume_strict: 2265847,
    },
    UCSF: {
      edit_count: 702126,
      edit_volume: 7084,
      edit_volume_strict: 685317,
    },
    UCOP: {
      edit_count: 18993,
      edit_volume: 458,
      edit_volume_strict: 18483,
    },
    UCM: {
      edit_count: -6200,
      edit_volume: 1768,
      edit_volume_strict: -6041,
    },
  },
  {
    year: 2021,
    UCLA: {
      edit_count: 6831891,
      edit_volume: 47629,
      edit_volume_strict: 6809180,
    },
    UCB: {
      edit_count: 60607,
      edit_volume: 39636,
      edit_volume_strict: 54530,
    },
    UCSC: {
      edit_count: -725796,
      edit_volume: 19343,
      edit_volume_strict: -733339,
    },
    UCSD: {
      edit_count: 1489766,
      edit_volume: 28913,
      edit_volume_strict: 1478607,
    },
    UCR: {
      edit_count: -253976,
      edit_volume: 8903,
      edit_volume_strict: -252695,
    },
    UCI: {
      edit_count: -462272,
      edit_volume: 23946,
      edit_volume_strict: -507090,
    },
    UCD: {
      edit_count: 567505,
      edit_volume: 21244,
      edit_volume_strict: 525313,
    },
    UCSB: {
      edit_count: 2293864,
      edit_volume: 25405,
      edit_volume_strict: 2272965,
    },
    UCSF: {
      edit_count: 733526,
      edit_volume: 7206,
      edit_volume_strict: 702095,
    },
    UCOP: {
      edit_count: 18729,
      edit_volume: 468,
      edit_volume_strict: 18993,
    },
    UCM: {
      edit_count: -4595,
      edit_volume: 1777,
      edit_volume_strict: -6200,
    },
  },
  {
    year: 2022,
    UCLA: {
      edit_count: 6892255,
      edit_volume: 47959,
      edit_volume_strict: 6829090,
    },
    UCB: {
      edit_count: 72679,
      edit_volume: 39899,
      edit_volume_strict: 56728,
    },
    UCSC: {
      edit_count: -703565,
      edit_volume: 19582,
      edit_volume_strict: -728320,
    },
    UCSD: {
      edit_count: 1496515,
      edit_volume: 29221,
      edit_volume_strict: 1526581,
    },
    UCR: {
      edit_count: -256366,
      edit_volume: 8952,
      edit_volume_strict: -250374,
    },
    UCI: {
      edit_count: -432082,
      edit_volume: 24356,
      edit_volume_strict: -469463,
    },
    UCD: {
      edit_count: 578761,
      edit_volume: 21486,
      edit_volume_strict: 564330,
    },
    UCSB: {
      edit_count: 2302127,
      edit_volume: 25583,
      edit_volume_strict: 2289924,
    },
    UCSF: {
      edit_count: 755283,
      edit_volume: 7339,
      edit_volume_strict: 728011,
    },
    UCOP: {
      edit_count: 18730,
      edit_volume: 469,
      edit_volume_strict: 18729,
    },
    UCM: {
      edit_count: 665,
      edit_volume: 1806,
      edit_volume_strict: -4595,
    },
  },
  {
    year: 2023,
    UCLA: {
      edit_count: 7058579,
      edit_volume: 48777,
      edit_volume_strict: 6887904,
    },
    UCB: {
      edit_count: -145817,
      edit_volume: 40266,
      edit_volume_strict: 80239,
    },
    UCSC: {
      edit_count: -674565,
      edit_volume: 20020,
      edit_volume_strict: -714994,
    },
    UCSD: {
      edit_count: 1543420,
      edit_volume: 29508,
      edit_volume_strict: 1533030,
    },
    UCR: {
      edit_count: -257179,
      edit_volume: 9039,
      edit_volume_strict: -252837,
    },
    UCI: {
      edit_count: -376403,
      edit_volume: 24653,
      edit_volume_strict: -442430,
    },
    UCD: {
      edit_count: 605465,
      edit_volume: 21696,
      edit_volume_strict: 579892,
    },
    UCSB: {
      edit_count: 2351391,
      edit_volume: 25809,
      edit_volume_strict: 2297710,
    },
    UCSF: {
      edit_count: 761961,
      edit_volume: 7458,
      edit_volume_strict: 759825,
    },
    UCOP: {
      edit_count: 18730,
      edit_volume: 470,
      edit_volume_strict: 18730,
    },
    UCM: {
      edit_count: 18047,
      edit_volume: 1873,
      edit_volume_strict: 349,
    },
  },
  {
    year: 2024,
    UCLA: {
      edit_count: 7503778,
      edit_volume: 50980,
      edit_volume_strict: 7097752,
    },
    UCB: {
      edit_count: -55191,
      edit_volume: 40714,
      edit_volume_strict: 146063,
    },
    UCSC: {
      edit_count: -667817,
      edit_volume: 20209,
      edit_volume_strict: -697316,
    },
    UCSD: {
      edit_count: 1558138,
      edit_volume: 30352,
      edit_volume_strict: 1576447,
    },
    UCR: {
      edit_count: -259919,
      edit_volume: 9094,
      edit_volume_strict: -253619,
    },
    UCI: {
      edit_count: -236622,
      edit_volume: 24929,
      edit_volume_strict: -399436,
    },
    UCD: {
      edit_count: 623055,
      edit_volume: 21900,
      edit_volume_strict: 602033,
    },
    UCSB: {
      edit_count: 2418618,
      edit_volume: 26071,
      edit_volume_strict: 2344777,
    },
    UCSF: {
      edit_count: 773935,
      edit_volume: 7545,
      edit_volume_strict: 766944,
    },
    UCOP: {
      edit_count: 18345,
      edit_volume: 470,
      edit_volume_strict: 18730,
    },
    UCM: {
      edit_count: 24278,
      edit_volume: 2054,
      edit_volume_strict: 17838,
    },
  },
  {
    year: 2025,
    UCLA: {
      edit_count: 7546719,
      edit_volume: 53514,
      edit_volume_strict: 7329914,
    },
    UCB: {
      edit_count: -42129,
      edit_volume: 41280,
      edit_volume_strict: 223489,
    },
    UCSC: {
      edit_count: -660301,
      edit_volume: 20437,
      edit_volume_strict: -684330,
    },
    UCSD: {
      edit_count: 1700196,
      edit_volume: 30769,
      edit_volume_strict: 1595920,
    },
    UCR: {
      edit_count: -260127,
      edit_volume: 9121,
      edit_volume_strict: -256369,
    },
    UCI: {
      edit_count: -199682,
      edit_volume: 25206,
      edit_volume_strict: -254462,
    },
    UCD: {
      edit_count: 646968,
      edit_volume: 22085,
      edit_volume_strict: 628098,
    },
    UCSB: {
      edit_count: 2443265,
      edit_volume: 26336,
      edit_volume_strict: 2399700,
    },
    UCSF: {
      edit_count: 773076,
      edit_volume: 7617,
      edit_volume_strict: 777515,
    },
    UCOP: {
      edit_count: 18349,
      edit_volume: 476,
      edit_volume_strict: 19506,
    },
    UCM: {
      edit_count: 30424,
      edit_volume: 2103,
      edit_volume_strict: 23965,
    },
  },
];

const perSchool = {
  UCB: {
    count: 41776,
    total_deletion: -5467643,
    total_addition: 5425514,
    net: -42129,
  },
  UCD: {
    count: 22271,
    total_deletion: -3938505,
    total_addition: 4585473,
    net: 646968,
  },
  UCI: {
    count: 25412,
    total_deletion: -4082182,
    total_addition: 3882500,
    net: -199682,
  },
  UCLA: {
    count: 54111,
    total_deletion: -7380722,
    total_addition: 14927441,
    net: 7546719,
  },
  UCM: {
    count: 2148,
    total_deletion: -154743,
    total_addition: 185167,
    net: 30424,
  },
  UCOP: {
    count: 477,
    total_deletion: -14781,
    total_addition: 33130,
    net: 18349,
  },
  UCR: {
    count: 9145,
    total_deletion: -1223301,
    total_addition: 963174,
    net: -260127,
  },
  UCSB: {
    count: 26560,
    total_deletion: -2418994,
    total_addition: 4862259,
    net: 2443265,
  },
  UCSC: {
    count: 20541,
    total_deletion: -3250567,
    total_addition: 2590266,
    net: -660301,
  },
  UCSD: {
    count: 32311,
    total_deletion: -4646963,
    total_addition: 6347159,
    net: 1700196,
  },
  UCSF: {
    count: 7675,
    total_deletion: -490254,
    total_addition: 1263330,
    net: 773076,
  },
};
export default data;
export { perSchool };
export { timeData };
